export default {
    service_price_modifiers: "Modificadores de Preço",
    service_cost_modifiers: "Modificadores de Custo",
    add_service_modifier: "Adicionar Modificador",
    modifier_name: "Nome do modificador",
    modifier_amount: "Valor",
    modifier_type: "Tipo",
    modifier_addition: "Adicional (+)",
    modifier_deduction: "Dedução (-)",
    no_modifiers_configured: "Nenhum modificador configurado para este serviço",
    no_cost_modifiers_configured: "Nenhum modificador de custo configurado para este serviço",
    applied_modifiers: "Modificadores",
    applied_modifiers_desc: "Ative ou desative modificadores para ajustar o preço",
    modifiers_count: "modificadores",
    manage_price_modifiers: "Gerenciar Modificadores",
    manage_cost_modifiers: "Gerenciar Modificadores de Custo",
    delete_modifier_confirm: "Excluir este modificador?",
    send_assignment_email: "Enviar atribuições por e-mail",
    send_email_to_business: "Enviar e-mail para o cliente",
    assigned_paxs_summary: "Você tem {{count}} paxs atribuídos para {{date}}",
    preview_message: "Pré-visualização da mensagem",
    active_reservations_in_date: "Reservas ativas em {{date}}",
    menu_permissions: "Permissões de Menu",
    create_action_permissions: "Permissões de Criação",
    create_permissions: "Permissões de Criação",
    allowed_views: "Visualizações Permitidas",
    allowed_create_actions: "Ações de Criação Permitidas",
    allowed_businesses: "Empresas Permitidas",
    no_businesses_allowed: "Sem empresas permitidas",
    full_access_desc: "Acesso total a todas as seções, ações e empresas sem restrições.",
    reservation_business_access: "Acesso a Empresas para Reservas",
    reservation_business_access_desc: "Escolha se este usuário pode criar reservas para qualquer empresa ou apenas empresas selecionadas específicas.",
    reservation_edit_access: "Acesso de Edição de Reservas",
    edit_prices_and_costs_manually: "Editar Preços e Custos Manualmente",
    edit_prices_and_costs_manually_desc: "Permite modificar e redefinir preços e custos de reservas manualmente.",
    no_manual_price_cost_access: "Sem edição manual de preços e custos",
    only_created_reservations: "Apenas Criadas pelo Usuário",
    edition_group_reservations: "Por Grupo de Edição",
    edition_group_reservations_desc: "O usuário pode editar reservas criadas por membros do mesmo grupo",
    edition_group: "Grupo de Edição",
    edition_groups: "Grupos de Edição",
    edition_group_desc: "Os usuários que pertençam ao mesmo grupo poderão editar as reservas dos outros membros.",
    create_edition_group: "Criar Grupo",
    edition_group_placeholder: "Nome do grupo (ex. Vendas, Recepção)...",
    existing_edition_groups: "Grupos existentes",
    no_edition_group_selected: "Nenhum grupo atribuído. O usuário só poderá editar suas próprias reservas.",
    users_in_group: "Membros do grupo",
    no_other_users_in_group: "Ainda não há outros usuários neste grupo.",
    no_edition_groups_created: "Nenhum grupo criado ainda. Digite um nome para criar o primeiro.",
    current_edition_group: "Grupo atualmente atribuído",
    clear_edition_group: "Remover grupo",
    selected_businesses: "Apenas Empresas Selecionadas",
    select_allowed_businesses: "Selecionar Empresas Permitidas",
    no_businesses_selected: "Nenhuma empresa selecionada. O usuário não poderá criar reservas para nenhuma empresa até que empresas sejam adicionadas.",
    unauthorized_business: "Você não está autorizado a criar reservas para esta empresa",
    filter_both: "Todos",
    filter_departures: "Partidas",
    filter_arrivals: "Chegadas",
    permissions: "Permissões",
    search_users: "Buscar usuários...",
    full_access: "Acesso Total",
    custom_access: "Acesso Personalizado",
    never: "Nunca",
    add_another_field: "Adicionar outro {{key}}",
    duplicate_client_warning: "Aviso de Cliente Duplicado",
    duplicate_client_name_desc: "Existem outros clientes com o nome '{{name}}'. Por favor, verifique se este cliente está correto.",
    duplicated_name: "Este nome já está registrado.",
    create_another: "Criar outro",
    create_child_reservation: "Criar Reserva Filha",
    derived_from_reservation: "Derivada da Reserva",
    parent_reservation_bookings: "Reservas da Reserva Original",
    original_reservation: "Reserva original",
    child_reservations: "Reservas derivadas",
    reservation_type: "Tipo de reserva",
    main_reservations_only: "Apenas principais (sem pai)",
    child_reservations_only: "Apenas derivadas (com pai)",
    contact_details: "Dados de Contato",
    account_overview: "Visão Geral da Conta",
    banking_info: "Informações Bancárias",
    quick_actions: "Ações Rápidas",
    tax_information: "Informações Fiscais",
    business_category: "Categoria da Empresa",
    account_status: "Status da Conta",
    cbu_alias: "CBU / Alias",
    no_bookings_in_parent: "Nenhuma reserva na reserva original",
    select_client_for_child_reservation: "Selecionar Cliente para Reserva Filha",
    select_client_to_assign_to_new_reservation: "Selecione o cliente a ser associado à nova reserva filha.",
    simulating_prices_for_selected_business: "Simulando preços personalizados para a empresa selecionada",
    select_business_to_view_custom_tariffs: "Selecione uma empresa para aplicar seus descontos de tarifa personalizados",
    budget: "Simulador de Tarifas",
    pinned_services: "Serviços Fixados",
    no_pinned_services: "Nenhum serviço fixado",
    click_to_pin: "Clique em qualquer cartão de serviço para fixá-lo neste simulador.",
    clear_all: "Limpar tudo",
    copy_summary: "Copiar Resumo",
    summary_copied: "Resumo copiado para a área de transferência!",
    total: "Total",
    settings_saved_success: "Configurações salvas com sucesso",
    enable_public_exchange_rates_title: "Habilitar Conversão de Moeda no Site Público",
    enable_public_exchange_rates_desc: "Permitir que os clientes no site público convertam preços para outras moedas usando estas taxas de câmbio. Se desativado, apenas os preços originais serão exibidos.",
    daily_evolution: "Evolução Diária",
    paxs_evolution: "Evolução de Passageiros",
    services_evolution: "Evolução de Serviços",
    money_evolution: "Evolução de Receitas e Custos",
    same_origin_destination_warning: "A origem e o destino não podem ser iguais.",
    complete_business_data: "Completar Dados da Empresa",
    legend: "Legenda",
    booking_pax_count_mismatch: "O total da reserva ({{categorySum}}) não coincide com os passageiros atribuídos ({{personsSum}})",
    complete_business_data_description: "Por favor, preencha as informações fiscais e de localização obrigatórias para esta empresa.",
    passenger_current_reservation: "Reserva Atual do Passageiro",
    group_all_bookings: 'Agrupar todas as reservas',
    loading_reservation: "Carregando reserva actual...",
    accept: 'Aceitar',
    slots: 'Vagas',
    occupied: 'ocupados',
    default_inventory_slots: 'Vagas Padrão',
    default_inventory_slots_desc: 'Número padrão de vagas ocupadas por este serviço ao ser reservado',
    access: 'Acesso',
    buy: 'Comprar',
    buy_services: 'Comprar Serviços',
    select_vendor: 'Selecionar Fornecedor',
    select_client_business: 'Selecionar Empresa Cliente',
    confirm_purchase: 'Confirmar Compra',
    purchase_successful: 'Compra bem-sucedida',
    error_during_purchase: 'Ocorreu um erro durante a compra',
    no_services_available: 'Não há serviços disponíveis deste fornecedor',
    back: 'Voltar',
    next: 'Avançar',
    select_vendor_placeholder: 'Escolha o parceiro para comprar',
    select_client_placeholder: 'Selecione sua empresa compradora',
    search_services: 'Buscar serviços por nome, categoria, cidade...',
    estimated_price: 'Preço Estimado',
    no_matching_services: 'Nenhum serviço corresponde à sua busca.',
    confirm_review_details: 'Por favor, revise os detalhes do seu pedido de reserva abaixo.',
    no_pricing_available: 'Detalhes de preços não resolvidos.',
    error: 'Erro',
    invalid_dates: 'Por favor, insira datas válidas',
    no_additional_attributes: 'Nenhum campo adicional é necessário.',
    no_paxs_selected: 'Nenhum passageiro selecionado',
    no_services_selected: 'Nenhum serviço selecionado',
    passenger: 'Passageiro',
    please_enter_pax_sizes: 'Por favor, insira um tamanho de grupo para pelo menos um passageiro',
    please_select_all_fields: 'Por favor, selecione todos os campos',
    reservation_created_successfully: 'Reserva criada com sucesso',
    step_confirm_price: 'Confirmar',
    step_from_who_whom: 'De / Para',
    step_paxs: 'Passageiros',
    step_select_services: 'Serviços',
    step_title: 'Passo {{step}}',
    group_size: 'Tamanho do Grupo',
    enter_start_day: 'Insira a data de início',
    account_settings: 'Configurações da conta',
    account_statement: 'Extrato da Conta',
    balance_as_client_disclaimer: 'Este saldo NÃO inclui reservas como fornecedor.',
    check_full_balance: 'Para ver o saldo completo, consulte a seção de Saldo',
    actions: 'Ações',
    actions_here_cannot_be_undone: 'As alterações feitas aqui não podem ser desfeitas',
    active: 'Ativo',
    active_costs: 'Custos Ativos',
    active_during_date: 'Ativo durante a data',
    active_filters: 'Filtros ativos',
    advanced_filters: 'Filtros Avançados',
    active_prices: 'Preços Ativos',
    active_services: 'Serviços Ativos',
    active_stock_periods: 'Períodos de estoque ativo',
    active_template: 'Modelo Ativo',
    active_today: 'Ativo hoje',
    activities: 'Atividades',
    activities_list: {
        generic_action: 'Ação',
        new_service_cost: 'Novo custo',
        new_service_price: 'Novo preço',
        reservation_person_added: 'Pessoa adicionada à reserva',
        reservation_person_removed: 'Pessoa removida da reserva',
        service_cost_created: 'Custo do serviço criado',
        service_cost_updated: 'Custo do serviço atualizado',
        service_price_created: 'Preço do serviço criado',
        service_price_updated: 'Preço do serviço atualizado'
    },
    activity: 'Atividade',
    activity_plural: 'Atividades',
    actual_payment: 'Pagamento Real',
    add: 'Adicionar',
    add_attribute: 'Adicionar atributo',
    add_booking: 'Adicionar reserva de serviço',
    add_bookings: 'Adicionar reservas',
    add_business: 'Adicionar empresa',
    add_child_cost: 'Adicionar custo mais baixo',
    add_child_item: 'Adicionar item abaixo',
    add_child_price: 'Adicionar preço mais baixo',
    add_child_service: 'Adicionar serviço ao pacote',
    add_cost: 'Adicionar Custo',
    add_discount: 'Adicionar desconto',
    add_discount_category: 'Adicionar categoria de desconto',
    add_exchange_rate: 'Adicionar taxa de câmbio',
    add_foreigner_cost: 'Adicionar custo estrangeiro',
    add_foreigner_price: 'Adicionar preço estrangeiro',
    add_infant_cost: 'Adicionar custo filho',
    add_infant_price: 'Adicionar preço secundário',
    add_money_in_out: 'Entrada/Saída',
    add_more_items: 'Adicione mais itens',
    add_new_attribute: 'Adicionar novo atributo',
    add_new_my_business: 'Adicionar nova empresa própria',
    add_new_payment: 'Adicionar Novo Pagamento',
    add_new_provider: 'Adicionar fornecedor',
    add_pax: 'Adicionar Pax',
    add_pax_to_housing: 'Adicionar Pax à hospedagem',
    add_pax_to_reservation: 'Adicionar Pax à reserva',
    add_pax_to_service: 'Adicionar Pax ao serviço',
    add_pax_to_transfer: 'Adicionar Pax à transferência',
    add_payment: 'Adicionar Pagamento',
    add_person: 'Adicionar pessoa',
    add_person_to_housing: 'Adicionar pessoa à acomodação',
    add_person_to_reservation: 'Adicionar pessoa à reserva',
    add_person_to_transfer: 'Adicionar pessoa para transferência',
    add_persons_to_vehicle_booking: 'Adicionar pessoas à reserva de veículo',
    add_price: 'Adicionar preço',
    add_prices: 'Adicionar preços',
    add_property: 'Adicionar propriedade',
    add_provider: 'Adicionar fornecedor',
    add_provider_cost: 'Adicionar custo do fornecedor',
    add_provider_price: 'Adicionar preço do fornecedor',
    add_providers: 'Adicionar fornecedores',
    add_provier: 'Adicionar fornecedor',
    add_reservation: 'Adicionar reserva',
    add_reservation_payment: 'Adicionar pagamento de reserva',
    add_reservation_status: 'Adicionar status de reserva',
    add_reservations: 'Adicionar reservas',
    add_senior_cost: 'Adicionar custo retirado',
    add_senior_price: 'Adicionar preço retirado',
    add_service: 'Adicionar Serviço',
    add_service_directly: 'Adicionar serviço diretamente',
    add_service_first_first: 'Adicione serviços primeiro',
    add_service_to_group: 'Adicionar serviço ao pacote',
    add_service_to_this_order: 'Adicionar serviço selecionado a este pedido',
    add_services: 'Adicionar Serviços',
    add_services_to_group: 'Adicionar serviços ao pacote',
    add_staff: 'Criar Staff',
    add_status: 'Adicionar status',
    add_stock_period: 'Adicionar período de estoque',
    add_tag: 'Adicionar Categoria',
    add_template: 'Adicionar modelo',
    add_time_slot: 'Adicionar agendamento',
    add_to_reservation: 'Adicionar à reserva',
    add_transaction: 'Adicionar Transação',
    add_user: 'Adicionar usuário',
    add_vehicle: 'Adicionar veículo',
    additional_details: 'Detalhes Adicionais',
    additional_notes: 'Notas Adicionais',
    address: 'Rua e Número',
    address_and_phone: 'Endereço e Telefone',
    admin: 'Administrador',
    adults: 'Adulto',
    affect_reservations: 'Afetar reservas',
    after_tomorrow: 'Depois de amanhã',
    age: 'Idade',
    agency: 'Agência',
    agenda: 'Agenda',
    agenda_orders: 'Agenda de pedidos',
    agenda_description: 'Gerencie os vencimentos de pagamento de reservas pendentes e próximas obrigações',
    agenda_overdue_alert: 'pagamentos de reservas vencidos que exigem atenção imediata',
    agenda_view_calendar: 'Calendário',
    agenda_view_list: 'Lista',
    agenda_view_timeline: 'Linha do Tempo',
    agenda_no_dues: 'Nenhum vencimento de reserva pendente encontrado',
    agenda_total_owed: 'Total Devido',
    agenda_dues_count: 'Vencimentos Pendentes',
    agenda_day_dues_title: 'Vencimentos de Pagamento para {{date}}',
    agenda_overdue_badge: 'Vencido',
    agenda_days_overdue: '{{count}}d vencido',
    agenda_due_in_days: 'Vence em {{count}}d',
    agenda_due_today: 'Vence hoje',
    agenda_view_reservation: 'Ver Reserva',
    agenda_copy_link: 'Copiar Link',
    agenda_all_dues: 'Todos os Vencimentos',
    agenda_overdue_only: 'Apenas Vencidos',
    agenda_upcoming_only: 'Apenas Próximos',
    agenda_category_unpaid_reservations: 'Reservas não pagas com data de vencimento',
    agenda_category_tickets: 'Tickets pendentes com prazo',
    agenda_filter_all: 'Todos',
    agenda_filter_reservations: 'Reservas',
    agenda_filter_tickets: 'Tickets',
    agenda_sort_date: 'Data',
    agenda_sort_category: 'Categoria',
    agenda_sort_assignee: 'Responsável',
    agenda_group_overdue: 'Vencidos',
    agenda_group_today: 'Vencem Hoje',
    agenda_group_upcoming: 'Próximos',
    agenda_group_no_date: 'Sem Prazo',
    agenda_no_items: 'Nenhum item da agenda encontrado',
    agenda_reservation_label: 'Reserva',
    agenda_ticket_label: 'Ticket',
    agenda_day_items_title: 'Agenda para {{date}}',
    agenda_show_completed: 'Mostrar concluídos',
    agenda_due_payment: 'Pagamento de reserva',
    agenda_view_single_list: 'Lista única',
    agenda_view_by_category: 'Por categoria',
    agenda_all_categories: 'Todas as categorias',
    assignments: 'Atribuições',
    reservation_assignments: 'Atribuições de Reservas',
    service_order_assignments: 'Atribuições de Ordens de Serviço',
    no_reservation_assignments: 'Sem atribuições de reservas',
    no_service_order_assignments: 'Sem atribuições de ordens de serviço',
    no_assignments_yet_desc: 'Quando outras agências reservarem serviços de suas empresas, elas aparecerão aqui.',
    no_results_for_search: 'Tente ajustar sua consulta de pesquisa',
    shared_booking: 'Reserva compartilhada',
    shared: 'Compartilhado',
    no_provider: 'Sem fornecedor',
    assigned_by: 'Atribuído Por',
    'ai-chat': 'Assistente de IA',
    'ai-chat-placeholder': 'Escreva sua mensagem...',
    ai_chat: 'Bate-papo com IA',
    ai_chat_placeholder: 'Escreva sua mensagem',
    ai_chat_thinking: 'pensando...',
    air: 'Aérea',
    all: 'tudo',
    all_businesses: 'Todas as empresas',
    all_categories: 'Todas as categorias',
    all_dates: 'Com e sem data',
    all_days: 'todos os dias',
    all_items: 'Todos os itens',
    all_my_business: 'Todas as minhas empresas',
    all_paxs: 'Todos os passageiros',
    all_persons: 'Todas as pessoas',
    all_plural: 'tudo',
    all_providers: 'Todos os fornecedores',
    all_rights_reserved: 'Todos os direitos reservados',
    all_service_bookings: 'Todas as reservas de serviço',
    all_services: 'Todos os serviços',
    all_types: 'Todos os tipos',
    alls: 'tudo',
    almost_there: 'quase pronto',
    also_update_linked_service: 'Atualize também o serviço de espelho',
    book_linked_service: 'Reservar também o serviço de espelho: {{name}}',
    book_linked_service_question: 'Reservar também este serviço de espelho?',
    normally_booked_together: 'Normalmente reservados juntos',
    amenities: 'Comodidades',
    amount: 'Quantidade',
    amount_paid_from: 'Pago por',
    amount_paid_to: 'Pago para',
    amount_to_pay: 'Valor a Pagar',
    amounts_match: 'Os valores coincidem',
    apartment: 'Apartamento',
    api_logs: {
        business_created: 'Novos negócios',
        business_deleted: 'Excluir empresa',
        business_updated: 'Atualizar negócios',
        inventory_item_created: 'Novo item de inventário',
        inventory_item_deleted: 'Excluir item de inventário',
        inventory_item_updated: 'Atualizar item de inventário',
        new_user_created: 'Novo usuário',
        person_created: 'nova pessoa',
        person_deleted: 'Excluir pessoa',
        person_updated: 'Atualizar pessoa',
        provider_created: 'Novo fornecedor',
        provider_deleted: 'Excluir fornecedor',
        provider_updated: 'Provedor de atualização',
        reservation_created: 'Nova reserva',
        reservation_deleted: 'Excluir reserva',
        reservation_person_added: 'Adicionar pessoa à reserva',
        reservation_person_removed: 'Remover pessoa da reserva',
        reservation_updated: 'Atualizar reserva',
        service_booking_created: 'Nova reserva de serviço',
        service_booking_deleted: 'Excluir reserva de serviço',
        service_booking_updated: 'Atualizar reserva de serviço',
        service_cost_created: 'Custo do novo serviço',
        service_cost_deleted: 'Elimine o custo do serviço',
        service_cost_updated: 'Atualizar custo do serviço',
        service_created: 'Novo serviço',
        service_deleted: 'Excluir serviço',
        service_group_created: 'Novo grupo de serviços',
        service_group_deleted: 'Excluir grupo de serviço',
        service_group_discount_updated: 'Atualizar pacote de serviços',
        service_group_updated: 'Atualizar grupo de serviço',
        service_order_created: 'Nova ordem de serviço',
        service_order_deleted: 'Excluir ordem de serviço',
        service_order_updated: 'Atualizar ordem de serviço',
        service_price_created: 'Novo preço do serviço',
        service_price_deleted: 'Excluir preço do serviço',
        service_price_updated: 'Atualizar preço do serviço',
        service_updated: 'Serviço de atualização',
        tenant_business_created: 'Novo inquilino',
        tenant_business_deleted: 'Excluir inquilino',
        tenant_business_updated: 'Atualizar inquilino',
        user_deleted: 'Excluir usuário',
        user_updated: 'Atualizar usuário'
    },
    apply: 'Aplicar',
    apply_changes: 'Aplicar alterações',
    apply_exchange: 'Aplicar Troca',
    archived: 'Arquivada',
    are_you_sure_delete_transaction: 'Tem certeza de que deseja excluir a transação?',
    arrival: 'Arribo',
    arrive: 'Chegada',
    assign: 'Atribuir',
    assign_bookings: 'Atribuir ordens de serviço',
    assign_inventory: 'Atribuir inventário',
    assign_service: 'Atribuir Serviço',
    assign_services: 'Atribuir Serviços',
    assign_to_order: 'Atribuir ao pedido',
    assigned_inventory: 'Inventário atribuído',
    assigned_services: 'Serviços com Atribuição',
    assigned_to_me: 'Atribuído a mim',
    assigned_vehicles: 'Veículos Designados',
    assignee: 'Atribuído',
    assistant: 'Assistente',
    assistant_plural: 'Ajudantes',
    assistants: 'Ajudantes',
    attachments: 'Anexos',
    attachments_urls: 'URLs de anexo',
    download_attachment: 'Baixar anexo',
    view_attachment: 'Ver anexo',
    failed_to_download_attachment: 'Falha ao baixar o arquivo anexo',
    attribute_key: 'Chave',
    attribute_name: 'Nome do Atributo',
    attribute_value: 'Valor',
    attributes: 'Atributos',
    availability: 'Disponibilidade',
    available: 'Disponível',
    available_inventory: 'Inventário disponível',
    available_places: 'vagas disponíveis',
    no_places_available: 'sem vagas disponíveis',
    available_service_orders: 'Ordens de serviço disponíveis',
    available_variables: 'Variáveis disponíveis',
    background_color: 'Cor de fundo',
    background_image_url: 'Fundo da imagem do URL',
    balance: 'Equilíbrio',
    bank_transfer: 'Transferência Bancária',
    banking_data: 'Dados Bancários',
    bank_name: 'Banco / Instituição Financeira',
    bank_account_holder: 'Titular da Conta',
    bank_account_number: 'Nº da Conta',
    bank_account_type: 'Tipo de Conta',
    bank_account_type_checking: 'Conta Corrente',
    bank_account_type_savings: 'Conta de Poupança',
    bank_cbu_iban: 'CBU / CVU / IBAN / CLABE',
    bank_alias: 'Alias / PIX / Apelido da Conta',
    bank_tax_id: 'CPF / CNPJ / CUIT / Tax ID',
    bank_swift_code: 'Código SWIFT / BIC',
    bank_notes: 'Notas ou Instruções Bancárias',
    base_price_zero: 'O preço base é zero',
    basic_info: 'Informações Básicas',
    basic_information: 'Informações Básicas',
    bath: 'Banheiro',
    bath_private: 'Banheiro privativo',
    bath_shared: 'Banheiro Compartilhado',
    baths: 'Banheiros',
    baths_number: 'Nº de banheiros',
    baths_type: 'Tipo de banheiros',
    bedroom: 'Quarto',
    bedrooms: 'Quartos',
    bedrooms_number: 'Quartos',
    beds: 'Camas',
    beds_number: 'Camas',
    beds_type: 'Tipo de camas',
    bike: 'Bicicleta',
    bike_rental: 'Aluguel de bicicletas',
    bike_rental_plural: 'Aluguel de bicicletas',
    block: 'Bloquear',
    boat: 'Barco',
    boat_rental: 'Aluguel de barco',
    boat_rental_plural: 'Aluguel de barcos',
    both: 'Ambos',
    book_service: 'Serviço de Reserva',
    booked_services: 'Serviços atribuídos',
    booking_attributes: 'Atributos de Reserva',
    booking_attributes_subtitle: 'Dados inseridos manualmente',
    booking_attrs: 'Atributos de reserva',
    booking_created: 'Reserva criada',
    booking_date: 'Data da Reserva',
    booking_details: 'Detalhes da Reserva',
    booking_limits: 'Limites de vendas',
    booking_successfully_created: 'Reserva criada com sucesso',
    group_size_exceeds_capacity: 'O tamanho do grupo excede a capacidade',
    capacity_warning_text: 'O serviço selecionado tem um limite de capacidade de {{capacity}} pax por reserva. Como o tamanho total do seu grupo é {{total}}, dividiremos isso em {{count}} reservas individuais de no máximo {{capacity}} pax cada. Gostaria de prosseguir?',
    all_bookings_successfully_created: 'Todas as reservas foram criadas com sucesso!',
    booking: 'Reserva',
    bookings: 'Reservas',
    bookings_and_reservations: 'Reservas',
    bookings_calendar: 'Agenda de serviços',
    bookings_client_provider: 'Reservas (Cliente/Fornecedor)',
    bookings_inventory_allocation: 'Alocação de estoque',
    bookings_limits_available: 'Limites de reserva disponíveis',
    bookings_per_reservation: 'Reservas - Reservas',
    bookings_per_service: 'Reservas - Serviço',
    bookings_search: 'Pesquisa de reservas',
    bookings_selected: 'Reservas Selecionadas',
    bookings_timeline: 'Cronograma de reserva',
    bookings_without_assign: 'Serviços não atribuídos',
    bought: 'Compras',
    bought_by_this_client: 'Comprado pelo cliente',
    branding: 'Marca',
    brands: 'Marcas',
    breakfast_type: 'Tipo de Café da Manhã',
    bulk_edit: 'Edição em massa',
    bulk_edit_businesses: 'Edição em Massa de Empresas',
    bulk_edit_services: 'Edição em massa de serviços',
    bulk_email_tariff_warning: 'Você está prestes a enviar uma atualização de tarifa para {{count}} empresas. Deseja continuar?',
    bulk_price: 'Alterar preços (fator)',
    bus: 'Ônibus',
    bus_number: 'Ônibus',
    business: 'Business',
    business_attributes: 'Atributos da empresa',
    business_balance: 'Balanço da Empresa',
    business_center: 'Centro de Negócios',
    business_name: 'Nome da empresa',
    business_tags: 'Categorias de Fornecedor',
    business_tariffs: 'Tarifário de Fornecedor',
    business_type: 'Tipo de negócio',
    business_types: {
        activities: 'Atividades e Experiências',
        agency: 'Agência de Viagens',
        hotel: 'Hotel',
        lodging: 'Hospedagem',
        other: 'Outro',
        restaurant: 'Restaurante',
        tour_operator: 'Operadora de Turismo',
        transportation: 'Transporte'
    },
    businesses: 'Businessess',
    no_tenant_business_error: 'Nenhuma empresa configurada para realizar transações. Por favor crie ou configure uma empresa na sua conta.',
    businesses_catalog: 'Catálogo de Negócios',
    businesses_description: 'Gerencie suas empresas',
    by: 'por',
    cabin: 'Cabine',
    cabins: 'Cabines',
    calendar: 'Calendário',
    calendar_inventory_items: 'Calendário de inventário',
    campaign: 'Campanha',
    campaign_send_error: 'Ocorreu um erro ao enviar a campanha. Por favor, tente novamente.',
    campaign_sent_description: 'Sua campanha foi colocada na fila e os e-mails serão enviados aos destinatários selecionados.',
    campaign_sent_successfully: 'Campanha enviada com sucesso',
    campaigns: 'Campanhas',
    cancel: 'Cancelar',
    cancelled: 'Cancelada',
    cant_edit_booking: 'Não é possível editar a reserva',
    cant_edit_booking_has_inventory_locks: 'A reserva possui bloqueios de inventário, não pode ser editada, você deve primeiro remover os bloqueios de inventário',
    capacity: 'Capacidade',
    capacity_and_ranking: 'Capacidade e Ordem',
    capacity_max: 'Capacidade Máxima',
    capacity_min: 'Capacidade Mínima',
    car: 'Carro',
    car_rental: 'Aluguel de carro',
    car_rental_plural: 'Aluguel de carros',
    car_rentals: 'Aluguel de veículos',
    carrier: 'Transporte',
    cash: 'Dinheiro',
    catalog: 'Catálogo',
    category: 'Categoria',
    category_name: 'Nome da categoria',
    change_linked_service: 'Alterar serviço de espelho',
    change_password: 'Alterar Senha',
    change_password_description: 'Atualize a senha da sua conta',
    check_availability: 'Verifique a disponibilidade',
    check_in: 'Check-in',
    check_in_hour: 'Horário de check-in',
    check_in_out: 'Check-in/check-out',
    check_out: 'Check-out',
    check_out_hour: 'Horário de check-out',
    check_times: 'Horários de Check-in & Check-out',
    checkbox: 'verificar',
    checking: 'Verificando',
    checking_availability: 'Verificando a disponibilidade',

    child_services: 'Pacote de serviços',
    child_services_description: 'Subserviços que compõem este pacote',
    children: 'Menor',
    choose_duration: 'Escolha a duração e os passageiros',
    cities: 'Cidades',
    city: 'Cidade',
    city_description: 'Cidade onde o serviço é oferecido',
    clear: 'Limpar',
    clear_dates: 'Excluir datas',
    clear_filters: 'Filtros limpos',
    filter_by_passenger: 'Filtrar por passageiro',
    clear_selection: 'Limpar seleção',
    click_to_edit_cost: 'Clique para editar o custo',
    click_to_edit_price: 'Clique para editar o preço',
    client: 'Cliente',
    client_balance: 'Saldo do cliente',
    client_bookings: 'Reservas de serviço',
    client_category_discount: 'Desconto por categoria de cliente',
    client_cost: 'Custo do cliente',
    client_cost_discount: 'Desc. Custo do cliente',
    client_cost_paid: 'Custo do cliente pago',
    client_discount: 'desconto cliente',
    client_history: 'História',
    client_income_received: 'Receita recebida do cliente',
    client_observations: 'Observações para o Cliente',
    client_reservations: 'Reservas como cliente',
    client_settlement: 'Liquidação do cliente',
    client_type: 'Tipo de cliente',
    client_unpaid_sells: 'Vendas a receber do cliente',
    clients: 'Clientes',
    clients_balance: 'Saldo do cliente',
    close: 'Fechar',
    copy: 'Copiar',
    copied: 'Copiado',
    admin_link: 'Link de Administração',
    public_link: 'Link Público (Para Clientes)',
    collapse: 'Recolher',
    collapse_all: 'Colapsar todos',
    color: 'Cor',
    comma_separated: 'separados por vírgulas',
    commercial_settings: 'Configuração Comercial',
    commercial_settings_desc: 'Gerencie a moeda padrão, categorias de desconto e dados bancários para transações.',
    company_information: 'Informações da empresa',
    company_name: 'Nome da empresa',
    company_name_or_name: 'Nome da empresa ou o seu',
    composition_mismatch_warning: 'A composição de paxs não coincide com o grupo original. Os preços serão recalculados automaticamente.',
    complete_before_continue: 'Conclua antes de continuar',
    complete_data: 'Dados completos',
    completed: 'Finalizada',
    concert: 'Concerto',
    concert_plural: 'Concertos',
    confirm: 'Confirmar',
    confirm_create_order: 'Confirmar a criação da ordem de serviço?',
    confirm_delete: 'Tem certeza de que deseja excluir este item?',
    confirm_delete_service_order: 'Tem certeza de que deseja excluir esta ordem de serviço?',
    confirm_delete_business: 'Tem certeza de que deseja excluir esta empresa?',
    delete_business_warning: 'Excluir permanentemente esta empresa e todas as suas configurações.',
    confirm_password: 'Confirmar senha',
    confirmed: 'Confirmado',
    consumed: 'Consumido',
    contact: 'Informações de Contato',
    contact_information: 'Informações de contato',
    contact_me: 'Quero mais informações',
    continue: 'Continuar',
    cooking: 'Cozinha',
    cooking_class: 'Aula de culinária',
    cooking_class_plural: 'Aulas de culinária',
    cooking_plural: 'Cozinhas',
    coordinator: 'Coordenador',
    coordinator_plural: 'Coordenadores',
    coordinators: 'Coordenadores',
    cost: 'Custo',
    cost_amount: 'Valor do custo',
    cost_breakdown: 'Detalhamento de Custos',
    cost_by: 'Custo para:',
    cost_by_description: 'Como será calculado o custo final?',
    cost_by_hour: 'custo por hora',
    cost_discount_default: 'Desconto de custo',
    cost_saved_successfully: 'Custo salvo com sucesso',
    cost_summary: 'Resumo de custos',
    costs: 'Custos',
    countries: {
        AE: 'Emirados Árabes Unidos',
        AR: 'Argentina',
        AT: 'Áustria',
        AU: 'Austrália',
        BE: 'Bélgica',
        BG: 'Bulgária',
        BO: 'Bolívia',
        BR: 'Brasil',
        BY: 'Bielorrússia',
        CA: 'Canadá',
        CH: 'Suíça',
        CL: 'Chile',
        CN: 'China',
        CO: 'Colômbia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CY: 'Chipre',
        CZ: 'República Tcheca',
        DE: 'Alemanha',
        DK: 'Dinamarca',
        DO: 'República Dominicana',
        DZ: 'Argélia',
        EC: 'Equador',
        EE: 'Estônia',
        EG: 'Egito',
        ES: 'Espanha',
        ET: 'Etiópia',
        FI: 'Finlândia',
        FR: 'França',
        GB: 'Reino Unido',
        GH: 'Gana',
        GR: 'Grécia',
        GT: 'Guatemala',
        HN: 'Honduras',
        HR: 'Croácia',
        HU: 'Hungria',
        ID: 'Indonésia',
        IE: 'Irlanda',
        IL: 'Israel',
        IN: 'Índia',
        IS: 'Islândia',
        IT: 'Itália',
        JP: 'Japão',
        KE: 'Quênia',
        KR: 'Coreia do Sul',
        LT: 'Lituânia',
        LV: 'Letônia',
        LY: 'Líbia',
        MA: 'Marrocos',
        MT: 'Malta',
        MX: 'México',
        MY: 'Malásia',
        NG: 'Nigéria',
        NI: 'Nicarágua',
        NL: 'Holanda',
        NO: 'Noruega',
        NZ: 'Nova Zelândia',
        PA: 'Panamá',
        PE: 'Perú',
        PH: 'Filipinas',
        PL: 'Polônia',
        PR: 'Porto Rico',
        PT: 'Portugal',
        PY: 'Paraguai',
        RO: 'Romênia',
        RS: 'Sérvia',
        RU: 'Rússia',
        SA: 'Arábia Saudita',
        SE: 'Suécia',
        SG: 'Singapura',
        SI: 'Eslovênia',
        SK: 'Eslováquia',
        SV: 'Salvador',
        TH: 'Tailândia',
        TN: 'Tunísia',
        TR: 'Turquia',
        TZ: 'Tanzânia',
        UA: 'Ucrânia',
        UK: 'Reino Unido',
        US: 'Estados Unidos',
        UY: 'Uruguai',
        VE: 'Venezuela',
        VN: 'Vietnã',
        ZA: 'África do Sul'
    },
    country: 'País',
    country_code: 'Código do país',
    cover_image: 'Imagem da capa',
    create: 'Criar',
    create_account: 'Criar conta',
    create_action_menu: 'Novo',
    create_another_campaign: 'Crie outra campanha',
    create_business: 'Criar fornecedor',
    create_inventory_item: 'Criar item de inventário',
    create_item_under_this_one: 'Criar item abaixo',
    create_multiple: 'Crie múltiplos',
    create_new_business: 'Criar novo fornecedor',
    create_new_order: 'Criar novo pedido',
    create_new_pax: 'Criar novo pax',
    create_new_payment: 'Criar Novo Pagamento',
    existing_pax_matches: 'Passageiros existentes',
    no_matching_pax_found: 'Nenhum passageiro correspondente encontrado',
    create_new_person: 'Criar nova pessoa',
    create_new_reservations: 'Criar nova reserva',
    create_new_service: 'Criar novo serviço',
    create_new_service_order: 'Criar nova ordem de serviço',
    create_new_vehicle: 'Criar novo veículo',
    create_order: 'Criar pedido',
    create_pax: 'Criar Pax',
    create_select_new_pax: 'Criar ou selecionar Pax',
    create_select_new_business: 'Criar ou selecionar Empresa',
    select_category: 'Selecionar categoria',
    search_permissions: 'Pesquisar permissões...',
    all_permissions_enabled: 'Todas as permissões habilitadas',
    no_permissions_enabled: 'Nenhuma permissão habilitada',
    manage_permissions: 'Gerenciar permissões',
    edit_user: 'Editar Usuário',
    confirm_delete_user: 'Tem certeza de que deseja excluir este usuário?',
    user_updated_successfully: 'Usuário atualizado com sucesso',
    user_deleted_successfully: 'Usuário excluído com sucesso',
    email_required: 'O e-mail é obrigatório',
    tenant: 'Tenant',
    you: 'Você',
    total_users: 'Total de Usuários',
    no_users_found: 'Nenhum usuário encontrado',
    no_users_found_desc: 'Tente ajustar sua pesquisa ou crie um novo usuário.',
    permission_overview: 'Resumo de Permissões',
    all_businesses_desc: 'Acesso a todas as empresas no sistema',
    selected_businesses_desc: 'Acesso restrito apenas a empresas especificadas',
    all_reservations_desc: 'O usuário pode editar todas as reservas',
    only_created_reservations_desc: 'O usuário só pode editar reservas criadas por ele mesmo',
    unknown_error: 'Ocorreu um erro desconhecido',
    never_logged_in: 'Nunca fez login',
    all_menu_permissions: 'Todas as Permissões de Menu',
    all_create_permissions: 'Todas as Permissões de Criação',
    back_to_users: 'Voltar para Usuários',
    new_password: 'Nova Senha',
    leave_blank_password_help: 'Digite uma nova senha para redefiní-la ou deixe em branco para manter a atual.',
    save_changes: 'Salvar Alterações',
    user_not_found: 'Usuário não encontrado',
    user_details: 'Detalhes do Usuário',
    account_details: 'Detalhes da Conta',
    business_and_scope_access: 'Escopo e Acesso a Empresas',
    create_payment: 'Criar Pagamento',
    create_reservation: 'Criar reserva',
    create_service: 'Criar serviço',
    create_service_bookings: 'Criar pedidos',
    create_service_order: 'Criar ordem de serviço',
    create_staff: 'Criar equipe',
    create_subscription: 'Criar assinatura',
    create_template: 'Criar modelo',
    create_ticket: 'Criar ingresso',
    create_user: 'Criar Usuário',
    create_vehicle: 'Criar veículo',
    created: 'Criado',
    created_at: 'Criado em',
    created_by: 'Criado por',
    created_by_me: 'Criado por mim',
    creating_booking: 'Criando Reserva',
    creator: 'Criador',
    credit_debit_card: 'Cartão de Crédito/Débito',
    cruise: 'Cruzeiro',
    currencies: {
        ARS: 'Peso Argentino (ARS)',
        BRL: 'Real Brasileiro (BRL)',
        CLP: 'Peso Chileno (CLP)',
        COP: 'Peso Colombiano (COP)',
        EUR: 'Euro (EUR)',
        GBP: 'Libra Esterlina (GBP)',
        MXN: 'Peso Mexicano (MXN)',
        PEN: 'Sol Peruano (PEN)',
        USD: 'Dólar Americano (USD)',
        UYU: 'Peso Uruguaio (UYU)',
        VEF: 'Bolívar Venezuelano (VEF)'
    },
    currency: 'Moeda',
    currency_exchange: 'Câmbio',
    'current-password-incorrect': 'A senha atual está incorreta',
    'current-password-required': 'A senha atual é obrigatória',
    current_password: 'Senha Atual',
    current_providers: 'Fornecedores atuais',
    custom_attributes: 'Atributos personalizados',
    custom_properties: 'Propriedades personalizadas',
    cycle: 'Ciclo',
    cycle_monthly: 'Mensalmente',
    cycle_yearly: 'Anual',
    daily: 'Diário',
    daily_cost: 'Custo Diário',
    daily_limit: 'Lim. Dia',
    dance_class: 'Aula de dança',
    dance_class_plural: 'Aulas de dança',
    danger_zone: 'Zona de perigo',
    dashboard: 'Painel',
    data: 'Dados',
    date: 'Data',
    date_and_time_for_service: 'Data e hora do serviço',
    date_of: 'Data de',
    date_optional_time: 'Data (hora opcional)',
    date_range: 'Período',
    dated: 'Com data',
    dates: 'Datas',
    day: 'Dia',
    day_of_month: 'Dia {{day}}',
    days: 'dias',
    days_arr: [
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
        'Domingo',
        'Fim de semana',
        'Todos os dias',
        'Segunda a Sexta'
    ],
    days_in: 'dias em',
    days_of_week: {
        friday: 'Sexta-feira',
        monday: 'Segunda-feira',
        saturday: 'Sábado',
        sunday: 'Domingo',
        thursday: 'Quinta-feira',
        tuesday: 'Terça-feira',
        wednesday: 'Quarta-feira'
    },
    days_of_week_short: {
        fri: 'Sex',
        mon: 'Seg',
        sat: 'Sáb',
        sun: 'Dom',
        thu: 'Qui',
        tue: 'Ter',
        wed: 'Qua'
    },
    days_range: {
        next_month: 'No próximo mês',
        next_week: 'Semana que vem',
        next_year: 'No próximo ano',
        ten_days: '10 dias',
        this_month: 'Este mês',
        this_week: 'Esta semana',
        today: 'Hoje',
        tomorrow: 'amanhã',
        yesterday: 'ontem'
    },
    default_currency: 'Moeda padrão',
    default_discounts: 'Descontos padrão',
    default_discounts_description: 'Eles podem ser modificados no serviço',
    default_language: 'Idioma padrão',
    default_limit: 'Limite padrão',
    default_limit_description: 'Máximo Pax por dia',
    default_limit_helper: 'Capacidade base aplicada a todos os dias do calendário, a menos que um valor individual específico seja definido.',
    default_value: 'Valor Padrão',
    custom: 'Personalizado',
    custom_limit: 'Limite personalizado',
    restore_default: 'Restaurar valor padrão',
    limit_update_success: 'Limite atualizado com sucesso',
    limit_update_error: 'Erro ao atualizar o limite',
    limits_are_based_on_price_by: 'Os limites diários consomem capacidade de acordo com as configurações de escala.',
    booked: 'Reservados',
    available_short: 'disp.',
    booked_short: 'ocup.',
    limit_short: 'lim.',
    sold_out: 'Esgotado',
    default_tariff_template: 'Modelo de taxa padrão',
    delete: 'Excluir',
    delete_selected: 'Excluir Selecionados',
    delete_booking: 'Excluir reserva de serviço',
    delete_booking_confirmation: 'Tem certeza de que deseja excluir esta reserva?',
    delete_dates: 'Excluir datas',
    delete_reservation: 'Excluir Reserva',
    delete_service: 'Excluir serviço',
    delete_service_group: 'Excluir pacote',
    delete_tag: 'Excluir Categoria',
    delete_transaction: 'Esta ação não pode ser desfeita',
    delete_user: 'Excluir usuário',
    departure: 'Partida',
    departure_time: 'Hora de Partida',
    description: 'Descrição',
    destination: 'Destino',
    destination_address: 'Endereço de destino',
    destination_city: 'Cidade de Destino',
    destination_zone: 'Zona de Destino',
    details: 'Detalhes',
    direction: 'Endereço',
    discard: 'Cancelar',
    discount: 'Desconto',
    discount_categories: 'Categorias de desconto',
    discount_categories_description: 'Valores padrão, cada serviço modificará esses valores',
    discount_category: 'Categoria de desconto',
    discount_category_desc: 'Atribua a categoria comercial aplicável a esta empresa para cálculo de tarifas e descontos.',
    discount_distributed_error: 'Erro ao distribuir o desconto',
    discount_distributed_success: 'Desconto distribuído com sucesso',
    discounts: 'Descontos',
    discounts_settings_desc: 'Defina categorias de desconto e regras para serviços.',
    discover_experiences: 'Descobrir Experiências',
    display_name: 'Nome de exibição',
    distribute: 'Distribuir',
    distribute_passengers: 'Distribuir Passageiros',
    do_you_want_to_apply_this_cost_to_linked_service: 'Deseja aplicar esse custo ao serviço de espelho?',
    do_you_want_to_apply_this_price_to_linked_service: 'Quer aplicar este preço ao serviço de espelho?',
    documentation: 'Documentação',
    done: 'Concluído',
    done_create_another_campaign: 'Pronto! Crie outra campanha.',
    dont_apply_client_discount: 'Não aplique desconto ao cliente',
    double_bed: 'Cama de Casal',
    double_beds: 'Camas de Casal',
    driver: 'Motorista',
    driver_information: 'Informações do Motorista',
    driver_license: 'Carta de condução',
    driver_plural: 'Motoristas',
    drivers: 'Motoristas',
    drivers_license: 'Carteira de Motorista',
    dropoff: 'Entrega',
    dropoff_location: 'Local de Entrega',
    due_date: 'Data de expiração',
    due_day: 'Dia de expiração',
    duplicate: 'Duplicar',
    update_service_data: 'Atualizar dados do serviço',
    duration: 'Duração',
    duration_and_paxs: 'Duração e Passageiros',
    duration_distance: 'Duração & Distância',
    edit: 'Editar',
    edit_attributes: 'Editar atributos',
    edit_business: 'Editar Fornecedor',
    edit_business_tag: 'Editar Etiqueta de Fornecedor',
    edit_cost: 'Editar custo',
    edit_inventory: 'Editar inventário',
    edit_payment: 'Editar pagamento',
    edit_price: 'Editar preço',
    edit_prices: 'Editar preços',
    edit_properties: 'Editar propriedades',
    edit_reservation: 'Editar Reserva',
    edit_selected: 'Editar selecionado',
    edit_service: 'Editar Serviço',
    edit_service_booking: 'Editar Reserva de Serviço',
    edit_service_group: 'Editar pacote de serviços',
    edit_service_tag: 'Editar Etiqueta de Serviço',
    edit_subscription: 'Editar assinatura',
    edit_tag: 'Editar Categoria',
    edit_tariffs: 'Editar taxa',
    edit_template: 'Editar modelo',
    edit_ticket: 'Editar ingresso',
    edit_vehicle: 'Editar Veículo',
    editing: 'Edição',
    editor: 'Editor',
    effective_date: 'Data de validade',
    email: 'Email',
    'email-and-password-required': 'E-mail e senha são obrigatórios',
    'email-required': 'O e-mail é obrigatório',
    email_campaigns: 'Campanhas de e-mail',
    email_history: 'Histórico de e-mail',
    email_send_error: 'Erro ao enviar e-mail',
    email_sent: 'Email enviado com sucesso',
    email_subject: 'Assunto do e-mail',
    email_subject_placeholder: 'Assunto da conversa',
    email_template: 'Modelo de e-mail',
    email_templates: 'Modelos de e-mail',
    emails: 'E-mails',
    emails_sent_successfully: 'E-mails enviados com sucesso',
    enable_manual_price: 'Ativar preços manuais',
    end: 'Fim',
    end_date: 'Data de Fim',
    end_hour: 'Hora de término',
    end_time: 'hora de término',
    ends: 'Termina',
    ends_between: 'Termina entre',
    ends_today: 'Último dia',
    enter_attribute_key: 'Insira a chave do atributo',
    enter_attribute_value: 'Insira o valor do atributo',
    enter_city: 'Digite a cidade',
    enter_default_limit: 'Insira o limite padrão',
    enter_different_foreigner_cost: 'Insira o custo para estrangeiros',
    enter_different_foreigner_price: 'Preço diferenciado para estrangeiros',
    enter_different_provider_cost: 'Insira o custo para fornecedores',
    enter_different_provider_price: 'Insira preços diferentes para fornecedores',
    enter_group_size: 'Inserir tamanho do grupo',
    enter_emails: 'Insira e-mails',
    enter_emails_manually: 'Insira e-mails manualmente',
    enter_observations: 'Insira observações',
    enter_payment: 'Insira o pagamento',
    enter_additional_emails: 'Inserir e-mails adicionais',
    enter_search_criteria: 'Selecione uma data e número de convidados para ver os serviços disponíveis',
    enter_status_name: 'Digite o nome do estado',
    equal: 'Igual',
    erase: 'Excluir',
    error_creating_payment: 'Erro ao criar pagamento',
    error_creating_service: 'Erro ao criar serviço',
    error_creating_reservation: 'Erro ao criar reserva',
    error_creating_service_order: 'Erro ao criar ordem de serviço',
    error_deleting_payment: 'Erro ao excluir pagamento',
    error_loading_vehicle: 'Erro ao carregar detalhes do veículo',
    error_loading_vehicles: 'Erro ao carregar veículos',
    error_sharing_reservation: 'Erro ao compartilhar a reserva',
    error_unsharing_reservation: 'Erro ao remover o acesso à reserva',
    errors: {
        'duplicate-request': 'Solicitação duplicada, aguarde.',
        'child-booking-pax-change-not-allowed': 'Não é permitido alterar o número de passageiros para serviços incluídos',
        error_duplicating_booking: 'Ocorreu um erro ao duplicar a reserva.',
        error_updating_booking: 'Erro ao atualizar a reserva. Por favor, tente novamente mais tarde.',
        'person-not-found': 'Pessoa não encontrada',
        'person-not-found-in-booking': 'Pessoa não encontrada na reserva',
        'service-booking-daily-available-limit-exceeded': 'Limite de disponibilidade diária excedido',
        'service-booking-not-found': 'Reserva de serviço não encontrada',
        'service-not-found': 'Serviço não encontrado'
    },
    exchange: 'Trocar',
    exchange_bookings_currency: 'Converter para moeda única',
    exchange_bookings_currency_description: 'De todos os serviços dentro da reserva',
    exchange_currency: 'Moeda de Câmbio',
    exchange_currency_description: 'Moeda na qual o pagamento foi recebido',
    exchange_rate: 'Taxa de Câmbio',
    exchange_rate_calculation: 'Taxa de câmbio para converter a moeda recebida para a moeda da reserva',
    exchange_rate_description: 'O pagamento foi recebido em uma moeda diferente da reserva',
    exchange_rates: 'Taxas de câmbio',
    exchange_rates_description: 'Defina taxas de câmbio para seus serviços e reservas',
    exchange_rates_settings_desc: 'Gerencie taxas de câmbio e configurações de várias moedas.',
    exclusive_client: 'Cliente Exclusivo',
    exclusive_rates: 'Preços Exclusivos',
    execution_status: 'Status de execução',
    exit_time: 'Hora de Saída',
    expand_all: 'Expandir todos',
    expected_amount: 'Valor Esperado',
    experience: 'Experiência',
    experience_plural: 'Experiências',
    external_reference: 'Referência Externa',
    extra_observations: 'Observações extras',
    extra_title_info: 'Informações extras',
    facilities: 'Facilidades',
    factor: 'fator',
    failed: 'Falhado',
    failed_to_fetch_dashboard_data: 'Falha ao buscar dados do painel',
    failed_to_load_reservation: 'Falha ao carregar a reserva',
    failed_to_send_emails: 'Falha ao enviar e-mails',
    favorite: 'Favorito',
    favorites: 'Favoritos',
    features: 'Características',
    ferry: 'Balsa',
    festival: 'Festival',
    festival_plural: 'Festivais',
    filter: 'Filtro',
    my_assignments: 'Minhas Atribuições',
    as_provider: 'Como Provedor',
    as_coordinator: 'Como Coordenador',
    filter_by: 'Filtrar por',
    filter_by_category: 'Filtrar por categoria',
    filter_by_date: 'Filtrar por data',
    filter_by_type: 'Filtrar por tipo',
    filter_inventory: 'Filtrar inventário',
    filter_rooms: 'Filtrar salas',
    filter_services: 'Filtrar serviços',
    filter_tours: 'Filtrar excursões',
    filter_transfers: 'Filtrar transferências',
    filters: 'Filtros',
    final_price: 'Preço Final',
    finalizing_booking: 'Finalizando reserva',
    finances: 'Finanças',
    financials: 'Finanças',
    flight: 'Voo',
    flight_in: 'Voo de chegada',
    flight_number: 'Número de Voo',
    flight_out: 'Voo de partida',
    font_family: 'Fonte (Google Fonts)',
    for: 'para',
    for_all_providers: 'Para todos os provedores',
    for_all_providers_leave_blank: 'Para todos os provedores, deixe em branco',
    for_businesses: 'de empresas',
    for_services: 'de serviços',
    foreigner: 'Estrangeiro',
    foreigner_price: 'Preço para Estrangeiros',
    from: 'De',
    from_currency: 'Moeda de Origem',
    fuel: 'Combustível',
    fulfillment: 'Execução e Composição',
    full: 'Total',
    full_duration: 'Reserva Completa',
    full_duration_uses_all_paxs_description: 'Selecione entre a reserva completa ou uma data/pax específica.',
    future: 'Futuro',
    general: 'Geral',
    general_information: 'Informações Gerais',
    go_to_business: 'Vá para a empresa',
    group_composition: 'Composição do Grupo',
    group_composition_description: 'O número de adultos, menores e bebês que fazem parte do grupo',
    step_1_group_size: '1. Tamanho do Grupo',
    step_2_passengers: '2. Vincular Passageiros',
    link_passengers: 'Vincular Passageiros',
    in_this_booking: 'Vinculados ao serviço',
    in_the_reservation: 'Disponíveis na reserva',
    define_group_size_first: 'Defina o tamanho do grupo no Passo 1.',
    group_complete: 'Todos os passageiros vinculados com sucesso!',
    missing_passengers_warning: 'Vincule mais {{count}} passageiro(s) para corresponder ao tamanho do grupo.',
    extra_passengers_warning: 'Existem {{count}} passageiro(s) a mais vinculados do que o tamanho do grupo.',
    link_passenger: 'Pesquisar e vincular passageiro...',
    group_a: 'Grupo A',
    group_a_name: 'Nome do Grupo A',
    group_b: 'Grupo B',
    group_b_name: 'Nome do Grupo B',
    group_names: 'Nomes dos Grupos',
    paxs_selected_unselected_tooltip: '{{selected}} atribuídos, {{unassigned}} não atribuídos',

    guest: 'Pax',
    guests: 'Hóspedes',
    guests_label: 'Passageiros não faturados (TC)',
    guests_description: 'Para guias, motoristas, etc. Não afetam o preço do serviço, mas são levados em consideração para os limites diários de disponibilidade.',
    guide: 'Guia',
    guide_plural: 'Guias',
    guides: 'Guias',
    gym: 'Ginásio',
    has_a_linked_service_same_price: 'Você tem um serviço conectado. Quer economizar o mesmo preço no serviço conectado?',
    has_access_to_provider_price: 'Acesso aos preços dos fornecedores',
    has_exchange_rate: 'Tem Taxa de Câmbio',
    has_money: 'Ele tem dinheiro a favor',
    helicopter: 'helicóptero',
    helicopter_rental: 'Aluguel de helicóptero',
    helicopter_rental_plural: 'Aluguel de helicóptero',
    hero_image_url: 'Herói da imagem do URL',
    hero_subtitle: 'Legenda do herói',
    hero_title: 'Herói do título',
    hide_assigned: 'Ocultar responsáveis',
    hide_bookings: 'Ocultar reservas',
    high: 'Alto',
    history: 'História',
    horizontal_axis_items: 'Tipo de Colunas',
    home: 'Página inicial',
    home_type: 'Tipo de Acomodação',
    hostel: 'Albergue',
    hostel_room: 'Quarto de albergue',
    hotel: 'Hotel',
    hour: 'Hora',
    hourly: 'Por hora',
    house: 'Casa',
    housing: 'Housing',
    housings: 'Hotéis',
    how_many: 'Quantos?',
    id: 'ID',
    id_card: 'Carteira de Identidade',
    id_number: 'Número de identificação',
    id_type: 'Tipo de identificação',
    identification: 'Identificação',
    im_the_owner: 'Eu sou o dono',
    image_delete_error: 'Erro ao excluir imagem',
    image_deleted: 'Imagem excluída com sucesso',
    image_upload_error: 'Erro ao carregar a imagem',
    image_uploaded: 'Imagem enviada com sucesso',
    images: 'Imagens',
    in_progress: 'Em andamento',
    in_use: 'Em Uso',
    include_bookings_without_dates: 'Incluir serviços sem datas',
    included_services: 'Serviços incluídos',
    includes: 'Incluídos',
    income: 'Receita',
    outcome: 'Despesas',
    incomes: 'Renda',
    incomplete: 'Incompleto',
    incomplete_data: 'Faltam dados',
    indoor_adventure: 'Aventura por dentro',
    indoor_adventure_plural: 'Aventuras internas',

    infants: 'Infantil',
    info: 'Informações',
    information: 'Informação',
    insurance_expiry: 'Vencimento do Seguro',
    interactive_view: 'Visualização Interativa',
    internal_use: 'Uso Interno',
    'invalid-credentials': 'Credenciais inválidas',
    inventory: 'Inventário',
    inventory_availability: 'Disponibilidade de inventário',
    inventory_calendar: 'Calendário',
    inventory_item: 'Item de inventário',
    inventory_items: 'Inventário',
    inventory_lock: 'Bloqueio de inventário',
    inventory_locks: 'Bloqueios de inventário',
    inventory_status: 'Status do inventário',
    irreversible_action: 'Ação irreversível',
    issue: 'Problema',
    is_favorite: 'É favorito',
    is_refund: 'Reembolso',
    is_refund_description: 'Se o pagamento é um reembolso, esta opção deve ser marcada',
    items: 'Itens',
    itinerary: 'Itinerário',
    its_my_business_info: 'Esta empresa será registrada como sua.',
    jacuzzi: 'Jacuzzi',
    join_turizi: 'Junte-se à Turizi',
    kilometers: 'Quilômetros',
    lake: 'Lago',
    landing: 'chegada',
    language: 'Idioma',
    language_class: 'Aula de idiomas',
    language_class_plural: 'Aulas de idiomas',
    language_description: 'Selecione o idioma do seu usuário',
    language_plural: 'Idiomas',
    language_settings_desc: 'Altere o idioma padrão e as opções regionais.',
    languages: {
        en: 'Inglês',
        es: 'Espanhol',
        pt: 'Português'
    },
    last_edited_reservations: 'Últimas reservas editadas',
    last_edited_services: 'Últimos serviços editados',
    last_login: 'Último login',
    last_maintenance: 'Última Manutenção',
    last_price: 'Preço mais recente',
    leave: 'Saída',
    leave_blank_to_keep_current_password: 'Deixe em branco para manter a senha atual',
    leave_empty_for_all_providers: 'Deixe em branco para todos os fornecedores',
    license_plate: 'Placa',
    limit: 'Limite',
    limits: 'Limites',
    link_business: 'Empresa de links',
    link_existing_payment: 'Vincular Pagamento Existente',
    link_payment: 'Vincular Pagamento',
    linked_service: 'Serviço de espelho',
    linked_service_description: 'Alterações de preços, descontos e reservas em reservas serão sincronizadas com o serviço',
    linked_to_reservation: 'Vinculado à reserva',
    liquidate_reservation: 'Liquidar Reserva',
    list: 'Lista',
    load_more: 'Carregar mais',
    loading: 'Carregando...',
    loading_price: 'Calculando...',
    location: 'Localização',
    location_and_branding: 'Localização e marca',
    locations: 'Localizações',
    lodging: 'Alojamento',
    lodging_type: 'Tipo de acomodação',
    login: 'Entrar',
    login_failed: 'Falha no login. Por favor tente novamente.',
    login_description: 'Faça login para continuar',
    login_popup_hint: "Faça login para clientes e provedores, consulte seus preços especiais e seu saldo aqui!",
    logistics: 'Logística',
    logo_url: 'URL do logotipo',
    logout: 'Sair',
    logs: 'Registros',
    low: 'Baixo',
    maintenance: 'Manutenção',
    make_me_owner_of_this_business: 'Sou legalmente responsável por esta empresa',
    make_model: 'Marca & Modelo',
    manage_housings_description: 'Visualizar e gerenciar todas as acomodações em hotéis.',
    manage_reservation_finances: 'Gerenciar finanças da reserva',
    manage_reservation_payments: 'Gerenciar pagamentos da reserva',
    manage_reservations_description: 'Visualizar e gerenciar todas as reservas dos businesses.',
    manage_transfers_description: 'Visualizar e gerenciar todas as transferências e transportes.',
    managed_businesses: 'Empresas Gerenciadas',
    managed_by_owner: 'Gerenciado por seu proprietário',
    managed_by_owner_description: 'Esta empresa é administrada pelo seu proprietário. Somente leitura.',
    manager: 'Gestor',
    management: 'Gestão',
    manifest: 'Manifesto',
    manual_emails: 'E-mails manuais',
    manual_entry: 'manual',
    manual_price_reason_placeholder: 'Ex. Desconto especial, etc...',
    mark_all_as_read: 'Marcar tudo como lido',
    mark_as_read: 'Marcar como lido',
    market: 'Mercado',
    max_bookings: 'Reservas Máximas',
    max_capacity: 'Capacidade máxima',
    max_pax: 'Máximo de Paxs',
    max_pax_per_booking: 'Número máximo de passageiros por reserva',
    max_pax_per_day: 'Máximo de passageiros por dia',
    max_paxs: 'Máximo de Paxs',
    max_per_day: 'Máx/dia',
    meal_plan: 'Regime',
    meditation: 'Meditação',
    meditation_class: 'Aula de Meditação',
    meditation_class_plural: 'Aulas de meditação',
    meditation_plural: 'Meditações',
    medium: 'Médio',
    member: 'Funcionário',
    members: 'Membros',
    menu: 'Menu',
    metadata: 'Metadados',
    method: 'Método',
    metrics: 'Métricas',
    metrics_dashboard: 'Painel de Métricas',
    total_money_in: 'Total de Vendas',
    selected_period: 'Período selecionado',
    all_payments: 'Todos os pagamentos',
    total_money_out: 'Total de Dinheiro Saindo',
    total_paid_in: 'Total Recebido',
    total_paid_out: 'Total Pago',
    sold_services: 'Serviços Vendidos',
    services_sold_by_bookings: 'Serviços por Reservas',
    services_sold_by_paxs: 'Serviços por Passageiros',
    services_sold_by_money_in: 'Serviços por Receita',
    services_sold_by_money_out: 'Serviços por Custos',
    services_sold_by_margin: 'Serviços por Margem',
    margin: 'Margem',
    by_amount_bookings: 'Por Quantidade de Reservas',
    by_amount_money: 'Por Quantidade de Dinheiro',
    total_bookings_manual_prices: 'Reservas com Preços Manuais',
    client_as_pax: 'Cliente como Passageiro',
    client_as_pax_pct_desc: 'de reservas com cliente pessoa',
    percentage_manual_price_higher: 'Preço Manual Maior que o Original',
    percentage_manual_price_lower: 'Preço Manual Menor que o Original',
    sales_by_client: 'Vendas por Cliente',
    group_sizes: 'Tamanhos de Grupos',
    bookings_count: 'Quantidade de Reservas',
    reservations_count: 'Quantidade de Reservas',
    manual_price_label: 'Preço Manual',
    higher: 'Maior',
    lower: 'Menor',
    net_balance: 'Saldo Líquido',
    group: 'Grupo',
    group_size_1: '1 Passageiro',
    group_size_2: '2 Passageiros',
    group_size_3_4: '3-4 Passageiros',
    group_size_5_8: '5-8 Passageiros',
    group_size_9_plus: '9+ Passageiros',
    last_30_days: 'Últimos 30 Dias',
    this_month: 'Este Mês',
    this_year: 'Este Ano',
    all_time: 'Todo o Tempo',
    manual_prices_breakdown: 'Detalhamento de Preços Manuais',
    pax_issues_spotter: 'Detector de Problemas de Pax',
    missing_lastname: 'Sem Sobrenome',
    single_name_warning: 'Nome único (sobrenome não detectado)',
    no_lastname_found: 'Nenhum passageiro sem sobrenome encontrado.',
    total_lastname_issues: 'Passageiros com nome único',
    view_pax: 'Ver Pax',
    view_business: 'Ver Empresa',
    sailing: 'Navegação',
    adventure: 'Aventura',
    kayak: 'Caiaque',
    rafting: 'Rafting',
    diving: 'Mergulho',
    ferry_company: 'Empresa de Ferry',
    clean_duplicates: 'Limpar Duplicados',
    duplicate_paxs: 'Passageiros Duplicados',
    total_duplicate_groups: 'Grupos Duplicados Encontrados',
    clean_all_duplicates: 'Limpar Todos os Duplicados',
    no_duplicates_found: 'Nenhum passageiro duplicado encontrado.',
    auto_clean: 'Limpeza Automática',
    keep: 'Manter',
    confirm_clean_all_duplicates: 'Tem certeza de que deseja limpar todos os duplicados? Isso manterá o registro mais antigo de cada nome duplicado e excluirá o restante.',
    confirm_clean_group_duplicates: 'Tem certeza de que deseja limpar automaticamente os duplicados para este passageiro?',
    mileage: 'Quilometragem',
    min_max_pax: 'Min-Max Pax',
    min_max_pax_per_booking: 'Mín-Máx Paxs',
    min_pax: 'Mínimo de Paxs',
    no_min: 'Sem mínimo',
    no_max: 'Sem máximo',
    min_pax_per_booking: 'Número mínimo de passageiros por reserva',
    min_paxs: 'Mínimo de Paxs',
    minutes: 'Minutos',
    money_business_owes: 'Dívida do Vendedor',
    money_in: 'Dinheiro Entrante',
    payment_from_client: 'Pagamento de Cliente',
    payment_to_provider: 'Pagamento a Fornecedor',
    money_in_adult: 'Preço adulto.',
    money_in_child: 'Preço mais baixo',
    money_in_infant: 'Preço infantil',
    money_in_senior: 'Preço do Jubileu.',
    money_in_total: 'Preço total',
    money_movement: 'Movimento de dinheiro',
    money_movements: 'Movimentos de dinheiro',
    money_out: 'Dinheiro Saínte',
    money_out_adult: 'Custo adulto.',
    money_out_child: 'Custo mais baixo',
    money_out_infant: 'Custo infantil.',
    money_out_senior: 'Custo de aposentadoria.',
    money_out_total: 'Custo total',
    money_owed_to_business: 'Devido ao vendedor',
    money_they_owe_us: 'Eles nos devem',
    money_transaction_reasons: {
        correction: 'Ajuste',
        future_payment: 'Pagamento por conta',
        other: 'outro',
        payment: 'Pagamento',
        refund: 'Reembolso'
    },
    money_transactions: 'Extrato da Conta',
    money_we_owe_them: 'Nós devemos a eles',
    money_will_be_collected: 'O dinheiro será coletado',
    money_will_be_refunded: 'O dinheiro será reembolsado',
    month: 'Mês',
    months: {
        april: 'Abril',
        august: 'Agosto',
        december: 'Dezembro',
        february: 'Fevereiro',
        january: 'Janeiro',
        july: 'Julho',
        june: 'Junho',
        march: 'Março',
        may: 'Maio',
        november: 'Novembro',
        october: 'Outubro',
        september: 'Setembro'
    },
    months_short: {
        apr: 'Abr',
        aug: 'Ago',
        dec: 'Dez',
        feb: 'Fev',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'Mai',
        nov: 'Nov',
        oct: 'Out',
        sep: 'Set'
    },
    more: 'mais',
    more_paxs: 'mais pessoas',
    motel: 'Motel',
    movements: 'Movimentos',
    multiply_last_price_by_this_factor: 'Multiplique o último preço por este fator',
    music: 'Música',
    music_class: 'Aula de música',
    music_class_plural: 'Aulas de música',
    music_festival: 'Festival de Música',
    music_festival_plural: 'Festivais de Música',
    music_plural: 'Música',
    my_business_split_info_1: 'Dividir as operações sob diferentes empresas ajuda a manter o balanço e a contabilidade mais organizados.',
    my_business_split_info_2: 'No entanto, TODOS os serviços continuarão sendo exibidos de forma unificada na mesma URL da sua loja online.',
    my_businesses: 'Minhas empresas',
    my_businesses_dashboard: {
        active_services: 'Serviços ativos',
        active_staff: '{{count}} funcionários ativos',
        advisor_issues_count: 'O consultor encontrou {{count}} problemas',
        ask_assistant: 'Consultar Assistente',
        business_profile: 'Perfil Comercial',
        business_website: 'Site',
        chart_pax: 'Passageiros (PAX)',
        chart_reservations: 'Reservas',
        chart_service_bookings: 'Ordens de serviço',
        chart_transactions: 'Transações',
        copied: 'Copiado!',
        copy_url: 'Copiar site',
        days_ago: '{{count}} dias atrás',
        error: 'Erro',
        get_started: 'Comece',
        healthy: 'Ativo',
        hours_ago: '{{count}}h atrás',
        last_activity: 'Última atividade',
        minutes_ago: '{{count}}m atrás',
        no_activity: 'Nenhuma atividade recente',
        no_businesses_found: 'Nenhuma empresa encontrada',
        no_businesses_found_desc: 'Crie sua primeira empresa na seção de administração para ver métricas, cronogramas e finanças em tempo real.',
        no_website: 'Nenhum site configurado',
        operational_activity: 'Atividade Operacional (Últimos 7 dias)',
        pending_payments: 'Pagamentos pendentes',
        phone_missing: 'telefone desaparecido',
        select_business: 'Selecione a empresa',
        staff_members: 'Pessoal Ativo',
        todays_bookings: 'Reservas de hoje',
        warning: 'Aviso',
        weekly_reservations: 'Reservas da Semana'
    },
    my_companies: 'Minhas empresas',
    name: 'Nome',
    name_list_placeholder: 'Digite um nome por linha...',
    nationality: 'Nacionalidade',
    net_amount: 'Valor Líquido',
    net_price: 'Preço Líquido',
    'new-password-required': 'A nova senha é obrigatória',
    new_account: 'Nova conta',
    new_business: 'Novo Fornecedor',
    new_campaign: 'Nova campanha',
    new_chat: 'Novo bate-papo',
    new_cost: 'Novo custo',
    new_housing: 'Novo Housing',
    new_inventory_item: 'Novo item de inventário',
    new_money_transaction: 'Nova Transação',
    new_order: 'Novo pedido',
    new_pax: 'Nova Pax',
    new_person: 'Nova Pessoa',
    new_price: 'Novo preço',
    new_register_money_transaction: 'Nova transação',
    new_reservation: 'Nova Reserva',
    new_reservation_payment: 'Novo Pagamento de Reserva',
    new_sell_price: 'Novo preço de venda',
    new_service: 'Novo Serviço',
    new_service_group: 'Novo pacote de serviços',
    new_service_order: 'Nova Ordem de Serviço',
    new_staff: 'Nova equipe',
    new_stock_period: 'Novo período de estoque',
    new_tab: 'Nova guia',
    new_ticket: 'Novo ingresso',
    new_vehicle: 'Novo Veículo',
    newsletter: {
        disclaimer: 'Ao se inscrever, você concorda em receber atualizações sobre o Turizi',
        getStarted: 'Começar',
        gotIt: 'Entendi',
        joinTitle: 'Junte-se ao Turizi',
        maybeLater: 'Talvez mais tarde',
        subscribeError: 'Falha na inscrição. Tente novamente.',
        subscribeSuccess: 'Inscrição realizada com sucesso!',
        subtitle: 'Sistema de Gestão Turística',
        successMessage: 'Está tudo pronto! Manteremos você informado com nossas últimas notícias.',
        title: 'Newsletter',
        welcome: 'Bem-vindo ao Turizi!'
    },
    next_10_days: 'Próximos 10 dias',
    next_14_days: 'Próximos 14 dias',
    next_7_days: 'Próximos 7 dias',
    next_maintenance: 'Próxima Manutenção',
    next_month: 'No próximo mês',
    night_and_pax_pricing: 'Noite e Pessoa',
    nights_pricing: 'noite',
    no: 'Não',
    'no-password-set': 'Nenhuma senha foi definida para esta conta. Por favor, use o link de acesso.',
    no_availability: 'Sem disponibilidade',
    no_bookings_found: 'Nenhuma reserva encontrada',
    no_categories_found: 'Nenhuma categoria encontrada',
    no_change: 'Sem alteração',
    no_changes_to_apply: 'Não há alterações a serem aplicadas',
    no_contact: 'Sem contato',
    no_cost: 'Sem custo',
    no_data: 'Sem dados',
    no_date: 'Sem data',
    no_discount: 'Sem desconto',
    no_due_date: 'Sem prazo',
    no_email_configured: 'Nenhum e-mail configurado',
    no_exchange_rate_found: 'Nenhuma taxa de câmbio encontrada no banco de dados.',
    no_inventory_selected: 'Nenhum inventário selecionado',
    no_limit: 'Sem limite',
    no_linked_service: 'Sem serviço de espelho',
    no_names: 'Sem nomes',
    no_columns_selected: 'Sem colunas selecionadas',
    select_columns_instruction: 'Escolha um tipo de coluna e selecione um ou mais itens acima para visualizar as reservas na matriz.',
    no_locks_for_this_day: 'Não há bloqueios para este dia',
    no_notifications: 'Sem notificações',
    no_only_this_service: 'Não, apenas este serviço',
    no_operational_services: 'Não há serviços operacionais atribuídos',
    no_payments_found: 'Nenhum pagamento encontrado',
    no_payments_found_for_this_client: 'Nenhum pagamento encontrado para este cliente',
    no_pending_tickets: 'Não há tickets pendentes',
    no_price: 'Inestimável',
    no_price_resolved: 'Preço não resolvido',
    no_provider_selected: 'Nenhum fornecedor selecionado',
    no_providers: 'Nenhum fornecedor',
    no_providers_assigned: 'Nenhum fornecedor adicionado',
    no_reservations: 'Não há reservas',
    no_reservation_associated_with_booking: 'Nenhuma reserva associada com a reserva',
    no_results: 'Nenhum resultado encontrado',
    no_service_orders: 'Sem ordens de serviço',
    no_services: 'Não há serviços',
    no_services_scheduled: 'Nenhum serviço agendado',
    no_statuses_defined: 'Nenhum status de reserva definido',
    no_template_selected: 'Nenhum modelo selecionado (usando filtros personalizados)',
    no_unpaid_reservations_found: 'Nenhuma reserva não paga encontrada',
    merge_business: 'Mesclar Empresa',
    merge_with_another_business: 'Mesclar com outra empresa',
    merge_business_description: 'Transfere todas as reservas, pagamentos, serviços e transações da empresa selecionada para esta e depois exclui permanentemente a empresa selecionada.',
    select_business_to_merge: 'Selecione a empresa para mesclar',
    select_source_business_to_delete: 'Selecionar empresa para mesclar e EXCLUIR',
    business_to_be_deleted: 'Empresa que será EXCLUÍDA permanentemente',
    business_to_be_kept: 'Empresa de destino (Mantida)',
    merge_and_delete_warning: 'AVISO CRÍTICO: Todos os dados serão transferidos para a empresa de destino. A empresa selecionada SERÁ EXCLUÍDA PERMANENTEMENTE!',
    merge_and_delete_action: 'Mesclar e Excluir Empresa',
    confirm_merge_business: 'Tem certeza de que deseja mesclar esta empresa? Esta ação não pode ser desfeita.',
    business_merged_successfully: 'Empresa mesclada com sucesso',
    error_merging_business: 'Erro ao mesclar empresa',
    cannot_merge_business_into_itself: 'Não é possível mesclar uma empresa em si mesma',
    no_upcoming_reservations: 'Nenhuma reserva próxima',
    no_upcoming_service_orders: 'Nenhuma ordem de serviço próxima',
    no_users_shared_with: 'Não há usuários com acesso compartilhado',
    no_vehicle_selected: 'Nenhum veículo atribuído',
    no_vehicle_type: 'Sem tipo de veículo',
    no_vehicles_assigned: 'Nenhum veículo designado',
    no_vehicles_found: 'Nenhum veículo encontrado',
    no_vehicles_scheduled_today: 'Nenhum veículo agendado para hoje',
    none: 'Nenhum',
    not_assigned: 'Não atribuído',
    not_available: 'Não disponível',
    not_specified: 'Não especificado',
    notes: 'Notas',
    notification_settings: 'Configuração de Notificações',
    notifications_settings: 'Configuração de Notificações',
    notifications_settings_desc: 'Configurar preferências de notificação e destinatários',
    emails_settings: 'Configurações de E-mail',
    emails_settings_desc: 'Configure e-mails da organização e endereços remetentes autorizados.',
    primary_email_label: 'E-mail Principal da Organização',
    primary_email_desc: 'Endereço de e-mail de contato principal da organização.',
    sender_emails_settings: 'E-mails Remetentes',
    sender_emails_settings_desc: 'Configure endereços de e-mail autorizados para enviar extratos, tarifas e reservas.',
    sender_emails_label: 'E-mails de Envio Autorizados',
    sender_emails_help_text: 'Digite um endereço de e-mail e pressione Enter para adicioná-lo à lista de remetentes autorizados. Você pode salvar quantos e-mails precisar.',
    authorized_emails_count: 'Endereços Remetentes Autorizados ({{count}})',
    primary: 'Principal',
    sender_email_placeholder: 'exemplo@empresa.com',
    select_sender_email: 'Enviar do e-mail',
    payment_request_receivers_label: 'Destinatários de Solicitação de Pagamento',
    payment_request_receivers_desc: 'Selecione quais usuários devem receber notificações quando um pagamento for solicitado de suas empresas.',
    pending_payment_request: 'Esta é uma solicitação de pagamento pendente.',
    mark_as_paid: 'Marcar como Pago',
    cancel_request: 'Cancelar Solicitação',
    notifications: {
        reservation_deleted: {
            content: '{{deleter_name}} excluiu a reserva #{{reservation_id}}.',
            title: 'Reserva Excluída'
        },
        reservation_payment_overdue: {
            content: 'A reserva #{{reservation_id}} está inadimplente. Valor: {{amount}}{{currency}}. Venceu em {{due_date}}',
            title: 'Reserva - Pagamento atrasado'
        },
        payment_overdue: {
            content: 'O pagamento #{{payment_id}} está vencido. Valor: {{amount}} {{currency}}. Venceu em {{due_date}}',
            title: 'Pagamento Vencido'
        },
        payment_request: {
            content: '{{from_business_name}} solicitou um pagamento de {{amount}} {{currency}}.',
            title: 'Solicitação de Pagamento Recebida'
        },
        ticket_assigned: {
            content: 'Você foi atribuído ao ticket: {{ticket_title}}',
            title: 'Novo ticket atribuído'
        },
        ticket_updated: {
            content: '{{updater_name}} atualizou o ticket: {{ticket_title}}',
            title: 'Ticket Atualizado'
        },
        ticket_commented: {
            content: 'Novo comentário de {{commenter_name}} no ticket: {{ticket_title}}',
            title: 'Novo Comentário no Ticket'
        },
        ticket_overdue: {
            content: 'O ticket "{{ticket_title}}" está atrasado',
            title: 'Ticket Atrasado'
        },
        booking_pax_count_mismatch: {
            content: 'A reserva #{{reservation_id}} tem uma discrepância entre a quantidade de passageiros e a lista de atribuídos.',
            title: 'Discrepância de Passageiros'
        },
        flight_status_changed: {
            content: 'O status do voo {{flight_number}} mudou para "{{new_status}}".',
            title: 'Status do Voo Atualizado'
        }
    },
    tracking_active: 'Rastreamento Ativo',
    tracked_flight_id: 'ID do Voo Registrado',
    tracked_flights: 'Voos Monitorados',
    today_flights: 'Voos de Hoje',
    future_flights: 'Voos Futuros',
    today_and_upcoming_flights: 'Voos de Hoje e Próximos',
    past_flights: 'Voos Anteriores',
    OUT: 'OUT',
    IN: 'IN',
    tracked_flights_description: 'Monitoramento automático em tempo real do status dos voos',
    search_tracked_flights_placeholder: 'Buscar por número do voo, código de origem/destino ou status...',
    no_tracked_flights_found: 'Nenhum voo rastreado encontrado',
    no_tracked_flights_help: 'Voos atribuídos a reservas de serviços aparecerão automaticamente aqui para rastreamento.',
    associated_reservations: 'Reservas associadas',
    mark_section_as_read: 'Marcar seção como lida',
    unread_count_label: '{{count}} não lidas',
    notifications_categories: {
        payments: 'Pagamentos',
        reservations: 'Reservas',
        tickets: 'Tickets e Suporte',
        flights: 'Voos e Logística',
        system: 'Sistema e Geral'
    },
    notifications_title: 'Notificações',
    number: 'Número',
    number_of_days: 'Não. Dias',
    number_short: 'Não.',
    observations: 'Observações',
    occupancy: 'Ocupação',
    odometer: 'Quilometragem',
    of: 'de',
    onboarding_description: 'Insira seus dados para começar.',
    onboarding_title: 'Crie seu grupo de trabalho',
    one_url_per_line: 'Um URL por linha',
    ongoing: 'Em Andamento',
    online_publishing: 'Publicação on-line',
    online_store: 'Loja on-line',
    online_store_description: 'Configure a loja online da sua empresa',
    online_store_settings_desc: 'Configure a integração e aparência da sua loja online.',
    only_pendings: 'Apenas brincos',
    open: 'Abrir',
    operated_by: 'Operado por',
    operation: {
        error: 'Erro',
        info: 'Informação',
        save_business: {
            error: 'Erro ao salvar empresa',
            success: 'Empresa salva com sucesso'
        },
        save_person: {
            error: 'Erro ao salvar pessoa',
            success: 'Pessoa salva com sucesso'
        },
        save_reservation: {
            error: 'Erro ao atualizar reserva',
            success: 'Reserva atualizada com sucesso'
        },
        save_service: {
            error: 'Erro ao salvar serviço',
            success: 'Serviço salvo com sucesso'
        },
        save_settings: {
            error: 'Erro ao salvar a configuração',
            success: 'Configuração salva com sucesso'
        },
        save_saved_report: {
            error: 'Erro ao salvar o filtro',
            success: 'Filtro salvo com sucesso'
        },
        save_shared_report: {
            error: 'Erro ao compartilhar relatório',
            success: 'Relatório compartilhado com sucesso'
        },
        delete_shared_report: {
            error: 'Erro ao excluir relatório compartilhado',
            success: 'Relatório compartilhado excluído com sucesso'
        },
        delete_saved_report: {
            error: 'Erro ao excluir o filtro',
            success: 'Filtro excluído com sucesso'
        },
        save_tag: {
            error: 'Erro ao salvar etiqueta',
            success: 'Etiqueta salva com sucesso'
        },
        save_template: {
            error: 'Erro ao salvar o modelo',
            success: 'Modelo salvo com sucesso'
        },
        add_subscription: {
            error: 'Erro ao adicionar assinatura',
            success: 'Assinatura adicionada com sucesso'
        },
        delete_subscription: {
            error: 'Erro ao excluir assinatura',
            success: 'Assinatura excluída com sucesso'
        },
        add_recurring_expense: {
            error: 'Erro ao adicionar despesa recorrente',
            success: 'Despesa recorrente adicionada com sucesso'
        },
        delete_recurring_expense: {
            error: 'Erro ao excluir despesa recorrente',
            success: 'Despesa recorrente excluída com sucesso'
        },
        cancel_recurring_expense: {
            error: 'Erro ao cancelar despesa recorrente',
            success: 'Despesa recorrente cancelada com sucesso'
        },
        save_recurring_expense: {
            error: 'Erro ao salvar despesa recorrente',
            success: 'Despesa recorrente salva com sucesso'
        },
        save_vehicle: {
            error: 'Erro ao salvar veículo',
            success: 'Veículo salvo com sucesso'
        },
        success: 'Operação exitosa',
        warning: 'Aviso'
    },
    operational_services: 'Serviços Operacionais',
    operations: 'Operações',
    operations_and_capacity: 'Operações e Capacidade',
    operator: 'Operador',
    operators: 'Operadores',
    opertor: 'Operador',
    optional: 'Opcional',
    options: 'Opções',
    options_text: 'Opções com texto',
    or: 'Ou',
    order: 'Pedido',
    orders: 'Pedidos',
    orders_calendar: 'Calendário de pedidos',
    orders_create: 'Pedidos - Criar',
    orders_management: 'Gerenciamento de pedidos',
    orders_show: 'Pedidos - Mostrar',
    origin: 'Origem',
    origin_address: 'Endereço de Origem',
    origin_city: 'Cidade de Origem',
    origin_zone: 'Zona de Origem',
    original_cost: 'Custo original',
    original_price: 'Preço original',
    original_total_price: 'Preço Total Original',
    other: 'outro',
    other_class: 'Classe Especial',
    other_class_plural: 'Aulas Especiais',
    outdoor_adventure: 'Aventura ao ar livre',
    outdoor_adventure_plural: 'Aventuras ao ar livre',
    over_paid: 'Pago em Excesso',
    overdue: 'expirou',
    overview: 'Resumo',
    owes: 'Deve',
    client_surplus_money: 'Saldo a favor do cliente',
    owes_money: 'devo dinheiro',
    owner: 'Proprietário',
    you_are_the_owner: 'Você é o proprietário desta empresa.',
    packages: 'Pacotes',
    pages: {
        home: {
            allRightsReserved: 'Todos os direitos reservados.',
            benefitsTitle: 'Transforme suas operações com resultados mensuráveis',
            contact: 'Contato',
            contactSubtitle: 'Estamos aqui para ajudá-lo a planejar sua viagem perfeita',
            contactUs: 'Entre em Contato',
            ctaSubtitle: 'Comece hoje e descubra como o Turizi pode revolucionar suas operações hoteleiras.',
            ctaTitle: 'Pronto para transformar seu negócio?',
            discoverExperiences: 'Descubra Experiências Incríveis',
            emailUs: 'Envie-nos um Email',
            exploreServices: 'Explorar Serviços',
            features: {
                accounting: {
                    description: 'Gestão financeira completa com faturamento automatizado, rastreamento de despesas e relatórios.',
                    title: 'Contabilidade e Finanças'
                },
                multiProperty: {
                    description: 'Gerencie propriedades ilimitadas de um único painel com controles unificados de inventário e preços.',
                    title: 'Gestão Multi-Propriedade'
                },
                revenueAnalytics: {
                    description: 'Gestão de preços dinâmicos, insights de ocupação e controle de gastos.',
                    title: 'Receitas/Despesas'
                },
                roomManagement: {
                    description: 'Inventário completo de quartos, cronogramas de limpeza e rastreamento de ocupação.',
                    title: 'Quartos'
                },
                smartBooking: {
                    description: 'Otimize as reservas de seus serviços e propriedades com programação e disponibilidade em tempo real.',
                    title: 'Reservas'
                },
                vehicleManagement: {
                    description: 'Gerencie sua frota com rastreamento, cronogramas de manutenção e otimização de rotas.',
                    title: 'Ônibus e Veículos'
                }
            },
            forBusinesses: 'Para Empresas',
            from: 'A partir de',
            getInTouch: 'Entre em Contato',
            getStarted: 'Comece Agora',
            heroHighlight: 'Serviços Turísticos',
            heroTitle: 'Plataforma de',
            landing: {
                automation: {
                    aiPowered: {
                        description: 'Assistente inteligente de IA para ajudar a gerenciar suas operações',
                        title: 'Assistência de IA'
                    },
                    analytics: {
                        description: 'Informações em tempo real sobre o desempenho do seu negócio',
                        title: 'Análise Inteligente'
                    },
                    instantProcessing: {
                        description: 'Automatize tarefas repetitivas e economize horas de trabalho manual',
                        title: 'Processamento Instantâneo'
                    },
                    timeTracking: {
                        description: 'Seu assistente digital funciona 24 horas por dia',
                        title: 'Disponibilidade 24 horas por dia, 7 dias por semana'
                    }
                },
                comparison: {
                    sectionBadge: 'Transformação Digital',
                    sectionSubtitle: 'Pare de perder tempo com processos manuais. Turizi digitaliza e automatiza todo o seu negócio de viagens.',
                    sectionTitle: 'Das operações manuais às automatizadas',
                    traditional: {
                        item1: 'Fluxos de trabalho em papel ou planilhas',
                        item2: 'Entrada manual de dados e cálculos',
                        item3: 'Colaboração e visibilidade limitadas',
                        item4: 'Propenso a erros humanos',
                        item5: 'Tarefas repetitivas e demoradas',
                        item6: 'Sem atualizações ou automação em tempo real',
                        title: 'Operações Manuais'
                    },
                    turizi: {
                        item1: 'Operações 100% digitais na nuvem',
                        item2: 'Cálculos e fluxos de trabalho automatizados',
                        item3: 'Colaboração e atualizações em tempo real',
                        item4: 'Processos automatizados sem erros',
                        item5: 'Tarefas automatizadas economizam horas diariamente',
                        item6: 'Automação e digitalização completas',
                        title: 'Plataforma Digital Automatizada'
                    }
                },
                cta: {
                    button: 'Comece agora',
                    description: 'Junte-se à revolução digital e automatize suas operações hoje mesmo.',
                    scheduleDemo: 'Agendar demonstração',
                    startTrial: 'Comece o teste gratuito',
                    title: 'Pronto para transformar sua agência de viagens?'
                },
                digitalFeatures: {
                    ai: {
                        badge: 'Alimentado por IA',
                        description: 'Faça perguntas, obtenha respostas instantâneas e gerencie suas operações usando linguagem natural. Nossa IA entende seu negócio e fornece respostas precisas e contextuais.',
                        feature1: 'Consultas em linguagem natural',
                        feature2: 'Recuperação instantânea de dados',
                        feature3: 'Disponibilidade 24 horas por dia, 7 dias por semana',
                        title: 'Assistente inteligente ao seu serviço'
                    },
                    badge: 'Ferramentas Digitais',
                    calendar: {
                        badge: 'Programação Inteligente',
                        description: 'Veja todas as suas reservas, passeios e atividades em um calendário unificado. Evite conflitos e otimize automaticamente a alocação de recursos.',
                        feature1: 'Visão unificada de todos os serviços',
                        feature2: 'Detecção automática de conflitos',
                        feature3: 'Otimização de recursos',
                        title: 'Gerenciamento automatizado de calendário'
                    },
                    finance: {
                        badge: 'Controle Financeiro',
                        description: 'Acompanhe pagamentos, saldos e métricas financeiras em tempo real. Automatize lembretes de cobrança e pagamento para melhorar o fluxo de caixa.',
                        feature1: 'Acompanhamento de saldo em tempo real',
                        feature2: 'Lembretes de pagamento automatizados',
                        feature3: 'Suporte multimoeda',
                        title: 'Visibilidade financeira completa'
                    },
                    title: 'Digitalize todos os aspectos da sua agência'
                },
                features: {
                    groupManagement: {
                        description: 'Gerencie digitalmente reservas de grupos complexos. Automatize atribuições de coordenação de viajantes, quartos e serviços em uma plataforma.',
                        title: 'Gerenciamento automatizado de grupo'
                    },
                    instantQuotes: {
                        description: 'Gere propostas digitais profissionais instantaneamente com cálculos automatizados de preços e verificação de disponibilidade.',
                        title: 'Cotações Digitais Instantâneas'
                    },
                    multiDestination: {
                        description: 'Automatize a coordenação de tours complexos com integração inteligente de fornecedores e sincronização de disponibilidade em tempo real.',
                        title: 'Automação multidestino'
                    },
                    payments: {
                        description: 'Digitalize suas finanças com faturamento automatizado, rastreamento de pagamentos e suporte multimoeda.',
                        title: 'Processamento de pagamento automatizado'
                    },
                    sectionBadge: 'Automação Digital',
                    sectionSubtitle: 'Desde a consulta inicial até o pagamento final, nossa plataforma automatiza e digitaliza todos os aspectos das operações das agências de viagens.',
                    sectionTitle: 'Automatize todo o seu negócio de viagens',
                    security: {
                        description: 'A criptografia de nível bancário e a conformidade com o GDPR garantem que suas operações digitais sejam seguras e protegidas.',
                        title: 'Infraestrutura digital segura'
                    },
                    smartScheduling: {
                        description: 'Criação automática de itinerário com detecção de conflitos e otimização baseada em IA para operações perfeitas.',
                        title: 'Automação de agendamento inteligente'
                    }
                },
                footer: {
                    about: 'Sobre',
                    api: 'API',
                    blog: 'blog',
                    careers: 'Carreiras',
                    community: 'Comunidade',
                    company: 'Empresa',
                    contact: 'Contato',
                    copyright: '© 2024 Turizi. Todos os direitos reservados.',
                    docs: 'Documentação',
                    features: 'Recursos',
                    gdpr: 'GDPR',
                    helpCenter: 'Central de Ajuda',
                    integrations: 'Integrações',
                    legal: 'Jurídico',
                    pricing: 'Preços',
                    privacy: 'Privacidade',
                    product: 'Produto',
                    resources: 'Recursos',
                    security: 'Segurança',
                    terms: 'Termos',
                    webinars: 'Seminários on-line'
                },
                hero: {
                    automation: 'Completa Automação e Digitalização de Processos',
                    noCreditCard: 'Sem cartão de crédito • Configuração em 15 minutos • Cancele a qualquer momento',
                    startTrial: 'Teste grátis por 14 dias',
                    subtitle: 'Transforme suas operações com a plataforma multifuncional projetada para',
                    subtitle2: 'agências de viagens e operadores turísticos',
                    title: 'Digitalização e Automação para Agências de Viagens',
                    watchDemo: 'Veja a demonstração'
                },
                nav: {
                    contact: 'Contato',
                    demo: 'Demonstração',
                    features: 'Recursos',
                    pricing: 'Preços',
                    signIn: 'Entrar',
                    startFreeTrial: 'Avaliação Gratuita'
                },
                showcase: {
                    badge: 'Plataforma Completa',
                    title: 'Tudo que você precisa em um só lugar'
                },
                stats: {
                    agencies: 'Agências de viagens',
                    satisfaction: 'Satisfação do Cliente',
                    setupTime: 'Tempo médio de configuração',
                    travelers: 'Viajantes gerenciados'
                },
                workflow: {
                    sectionBadge: 'Transformação Digital',
                    sectionTitle: 'Digitalize e automatize todo o seu fluxo de trabalho',
                    step1: {
                        description: 'Transforme seus serviços, acomodações e atividades em ativos digitais com preços automatizados e disponibilidade em tempo real.',
                        title: 'Digitalize seu inventário'
                    },
                    step2: {
                        description: 'Use nossa interface digital de arrastar e soltar para criar itinerários com preços automatizados, verificação de disponibilidade e detecção de conflitos.',
                        title: 'Automatize a criação de itinerários'
                    },
                    step3: {
                        description: 'Geração automatizada de propostas com um clique. Os documentos digitais incluem mapas, fotos e análises detalhadas.',
                        title: 'Gere propostas digitais instantaneamente'
                    },
                    step4: {
                        description: 'Painéis digitais para reservas, pagamentos e documentos. Lembretes e notificações automatizados mantêm as operações funcionando perfeitamente.',
                        title: 'Gerenciamento automatizado de operações'
                    }
                }
            },
            limitedAvailability: 'Disponibilidade limitada',
            localExpertise: 'Expertise Local',
            localExpertiseDesc: 'Conhecimento profundo de destinos e joias escondidas',
            login: 'Entrar',
            or: 'ou',
            ourBusinesses: 'Nossos Negócios Parceiros',
            ourServices: 'Nossos Serviços',
            perPerson: 'por pessoa',
            publishYourService: 'Saiba Mais',
            qualityService: 'Serviço de Qualidade',
            qualityServiceDesc: 'Atenção personalizada e experiências memoráveis',
            questions: 'Dúvidas? Entre em contato em',
            sendMessage: 'Envie-nos uma mensagem',
            servicesSubtitle: 'Escolha entre nossos tours e atividades cuidadosamente selecionados',
            variedOptions: 'Opções Variadas',
            variedOptionsDesc: 'Ampla gama de tours para cada viajante',
            viewAllServices: 'Ver todos os {{count}} serviços',
            viewDetails: 'Ver Detalhes',
            welcome: 'Bem-vindo ao {{name}}',
            whyChooseUs: 'Por que nos Escolher?',
            whyChooseUsSubtitle: 'Seu parceiro confiável para viagens inesquecíveis'
        }
    },
    paid: 'Pago',
    paid_amount: 'Pago',
    remaining_amount: 'Restante',
    surplus: 'A favor',
    painting: 'Pintura',
    painting_class: 'Aula de Pintura',
    painting_class_plural: 'Aulas de pintura',
    painting_plural: 'Pinturas',
    parent_inventory_item: 'Item principal',
    parking: 'Estacionamento',
    partial: 'Parcial',
    partially_paid: 'Pago Parcialmente',
    partially_refunded: 'Parcialmente Reembolsado',
    passenger_data: 'Detalhes do passageiro',
    passenger_info: 'Informações do passageiro',
    passenger_type: 'Tipo de Passageiro',
    passengers: 'Passageiros',
    passengers_per_day: 'Pessoas por dia',
    passport: 'Passaporte',
    password: 'Senha',
    'password-required': 'A senha é obrigatória',
    password_changed_successfully: 'Senha alterada com sucesso',
    passwords_do_not_match: 'As senhas não coincidem',
    paste_a_list_of_names: 'Cole uma lista de nomes',
    pax: 'Pax',
    pax_count: 'Pax',
    pax_assigned_count: '{{assigned}} / {{total}} atribuídos',
    pax_description: 'Pessoa ou Grupo que viaja e paga pelo serviço',
    pax_number_question: 'Nº de pessoas',
    pax_pricing: 'Pessoa',
    pax_seats: 'Paxs / Assentos',
    paxs: 'Paxs',
    paxs_capacity: 'Capacidade de passageiros',
    paxs_capacity_description: 'Deixe em branco para não limitar a capacidade deste item',
    paxs_catalog: 'Catálogo Paxs',
    paxs_description: 'Gerencie seus passageiros',
    payed_amount: 'Pago',
    payee: 'Beneficiário',
    payer: 'Quem Paga',
    payer_information: 'Informações do Pagador',
    payment: 'Pagamento',
    applied_amount: 'Valor Aplicado',
    applied_amounts: 'Valores Aplicados',
    distribute_evenly: 'Distribuir Igualmente',
    fill_needed_amounts: 'Preencher Saldos Necessários',
    payment_created_successfully: 'Pagamento criado com sucesso',
    payment_date: 'Data do Pagamento',
    payment_deleted_successfully: 'Pagamento excluído com sucesso',
    payment_done: 'Pagamento realizado',
    payment_done_desc: 'O pagamento foi feito corretamente',
    payment_failed: 'Pagamento Falhado',
    payment_full: 'Pagamento Total',
    payment_intent: 'Intenção de pagamento',
    payment_issue_warning: 'Valor inválido ou emissor/receptor idênticos',
    payment_method: 'Método de Pagamento',
    payment_methods: {
        bank_transfer: 'Transferência Bancária',
        card: 'Cartão de Crédito/Débito',
        cash: 'Dinheiro',
        paypal: 'PayPal',
        reconciling: 'Conciliação',
        service_reciprocity: 'Atendimento por Reciprocidade',
        stripe: 'Stripe',
        wallet_transfer: 'Carteira Digital'
    },
    by_payment_method: 'Por método de pagamento',
    no_transactions: 'Sem transações',
    payment_partial: 'Pagamento Parcial',
    payment_pending: 'Pendente',
    payment_status: 'Status de pagamento',
    reconcile_payments: 'Conciliar Pagamentos',
    see_reconciliation_details: 'Ver Detalhes da Conciliação',
    reconciliation_triggered_successfully: 'Conciliação concluída com sucesso',
    reconciliation_failed: 'Falha na conciliação',
    reconciliation_executed_successfully: 'Reconciliação executada com sucesso',
    match: 'Coincidência',
    find_matches_title: 'Buscar Coincidências de Reconciliação',
    no_matches_found: 'Nenhuma coincidência não conectada encontrada.',
    reconcile_confirm_title: 'Conciliar Pagamentos',
    reconcile_confirm_desc: 'Selecione as coincidências propostas que deseja executar. Apenas pagamentos e reservas sem vínculo são processados.',
    reconcile_execute_button: 'Executar Reconciliação',
    reconcile_match_payment: 'Pagamento',
    reconcile_match_reservation: 'Reserva',
    reconcile_match_amount: 'Valor a Vincular',
    reconcile_find_error: 'Falha ao buscar coincidências de reconciliação',
    payment_type: 'Tipo de Pagamento',
    payment_types: {
        cancellation_fee: 'Taxa de cancelamento',
        fee: 'Taxa',
        full: 'Total',
        partial: 'Parcial',
        refund: 'Reembolso'
    },
    payments: 'Pagamentos',
    payments_income: 'Cobranças',
    payments_outcome: 'Pagamentos externos',
    payments_history: 'Histórico de Pagamentos',
    paypal: 'PayPal',
    pdf_view: 'Visualização de PDF',
    pending: 'Não confirmado',
    pending_payments: 'Pagamentos Pendentes',
    pending_tickets: 'Ingressos Pendentes',
    people: 'Pessoas',
    percentage: 'Porcentagem',
    period: 'Período',
    person: 'Pessoa',
    person_type_pricing: 'Por pessoa',
    person_updated_successfully: 'Pessoa atualizada com sucesso',
    persons: 'Pessoas',
    phone: 'Telefone',
    phones: 'Telefones',
    photography: 'Fotografia',
    photography_class: 'Aula de fotografia',
    photography_class_plural: 'Aulas de fotografia',
    photography_plural: 'Fotografias',
    pickup: 'Retirada',
    pickup_date: 'Data de Retirada',
    pickup_location: 'Local de Retirada',
    plane: 'avião',
    plane_rental: 'Aluguel de avião',
    plane_rental_plural: 'Aluguel de aeronaves',
    planned_services: 'Serviços agendados',
    please_select_start_and_end_time: 'Selecione a data e hora de início e término',
    please_select_the_passengers_for_this_booking: 'Selecione passageiros para esta reserva',
    policies: 'Políticas',
    postal_code: 'Código Postal',
    precio_manual: 'preço manual',
    preview: 'Visualização',
    price: 'Preço',
    pvp: 'PVP',
    standard_retail_price: 'PVP',
    price_breakdown: 'Detalhe do preço',
    price_by: 'Preço Por',
    price_by_description: 'O preço será calculado por dia, pax ou serviço',
    price_by_hour: 'por Hora',
    price_by_night: 'por Noite',
    price_by_night_and_pax: 'por Noite e Pessoa',
    price_by_pax: 'por Pessoa',
    price_by_service: 'por Serviço',
    price_calculated_by: 'Preço calculado por:',
    price_cost_error: 'O preço de venda deve ser maior que o preço de custo',
    price_factor: 'Fator de preço',
    price_period: 'Período de preço',
    price_saved_successfully: 'Preço salvo com sucesso',
    price_summary: 'Resumo de Preços',
    prices: 'Preços',
    pricing: 'Preços',
    pricing_error_desc: 'Falha ao recuperar os preços para um ou mais serviços. Por favor, verifique as datas e parâmetros.',
    pricing_error_title: 'Erro de Tarifas',
    primary_color: 'Cor Primária',
    privacy: 'Privacidade',
    private: 'Privado',
    private_categories: 'Categorias Privadas',
    private_fm: 'Privado',
    private_room: 'Quarto Privado',
    private_service: 'Privado',
    private_vehicle: 'Veículo particular',
    privates: 'Privado',
    processing: 'Processamento',
    processing_your_request: 'Processando sua solicitação',
    products: 'Produtos',
    profile: 'Perfil',
    profit: 'Lucro',
    proportional: 'Proporcional',
    provided_by_other: 'Fornecido por terceiros',
    provider: 'Fornecedor',
    provider_only_bookings: 'Reservas de serviços fornecidas por',
    provider_price: 'Preço do fornecedor',
    provider_services: 'Provedor de serviços',
    provider_specific_cost: 'Este custo será aplicado a um fornecedor específico',
    provider_specific_price: 'Este preço será aplicado a um fornecedor específico',
    providers: 'Fornecedores',
    providing_services: 'Serviços prestados',
    province: 'Província',
    public: 'Público',
    public_categories: 'Categorias Públicas',
    public_rank: 'Classificação pública (web/taxa)',
    public_services: 'Taxa de compartilhamento',
    public_tariffs: 'Taxa Pública',
    publish_price: 'Publicar Preços em Tarifário?',
    publish_price_description: 'Ative esta opção para exibir este serviço e seus preços na loja online para compras de clientes externos.',
    publish_prices: 'Publicar Preços de Serviços em Tarifário?',
    published: 'Publicado',
    published_prices: 'Preços Publicados',
    purchase_date: 'Data de Compra',
    quantity: 'Unidades',
    quantity_description: 'Quantidade do mesmo item',
    rack: 'Prateleira',
    rank: 'Classificação',
    ready: 'Pronto',
    reason: 'Razão',
    received_currency: 'Moeda Recebida',
    recipient: 'Destinatário',
    recipients: 'Destinatários',
    recipients_list: 'Lista de destinatários',
    records: 'Registros',
    refresh: 'Atualizar',
    refund: 'Reembolso',
    refunded: 'Reembolsado',
    regime: 'Regime',
    regimen: 'Regime',
    register_money_transaction: 'Cadastrar Pagamento',
    regular: 'Regular',
    regular_schedule: 'Normal',
    regulars: 'Normal',
    reply_to_existing_conversation: 'Responder a uma conversa de e-mail existente',
    remove: 'Excluir',
    remove_bookings: 'Retire reservas',
    remove_from_order: 'Remover do pedido',
    remove_from_reservation: 'Remover da reserva',
    remove_pax: 'Remover Pax',
    remove_staff: 'Remover Staff',
    remove_stock_period: 'Excluir período de estoque',
    remove_stock_period_confirmation: 'Tem certeza de que deseja eliminar este período de estoque?',
    remove_stock_period_confirmation_message: 'Tem certeza de que deseja eliminar este período de estoque?',
    remove_stock_period_confirmation_title: 'Excluir período de estoque',
    rental_house: 'Casa de aluguel',
    required_info: 'Informações necessárias',
    required_information: 'Informações Obrigatórias',
    required_number_of_service_orders: 'Número de pedidos necessários',
    required_service_orders: 'Ordens de Serviço Necessárias',
    requested_amount: 'Valor Solicitado',
    linked_payments: 'Pagamentos Vinculados',
    payments_count: '{{count}} pagamentos',
    unlinked_payments: 'Pagamentos Sem Vincular',
    reservation: 'Reserva',
    reservation_cancelled: 'Cancelado',
    reservation_cancelled_plural: 'Cancelado',
    reservation_completed: 'Concluído',
    reservation_confirmed: 'Confirmado',
    reservation_confirmed_plural: 'Confirmado',
    reservation_in_progress: 'Em Curso',
    reservation_finished: 'Finalizada',
    reservation_date: 'Data da Reserva',
    reservation_dates: 'Datas de reserva',
    reservation_details: 'Detalhes da Reserva',
    reservation_future: 'Em breve',
    reservation_id: 'ID da Reserva',
    reservation_number: 'Número de Reserva',
    reservation_ongoing: 'Em andamento',
    reservation_paxs: 'Passageiros Reservados',
    reservation_payments: 'Pagamentos da Reserva',
    reservation_pending: 'Citação',
    reservation_pending_plural: 'Citações',
    reservation_price: 'Preço da Reserva',
    reservation_shared_successfully: 'Reserva compartilhada com sucesso',
    reservation_status: {
        archived: 'Arquivado',
        cancelled: 'Cancelado',
        completed: 'Completado',
        confirmed: 'Confirmado',
        pending: 'Pendente',
        running: 'Em curso'
    },
    reservation_statuses: 'Estados de reserva',
    reservations_by_status: 'Reservas por Estado',
    reservation_unshared_successfully: 'Acesso à reserva removido com sucesso',
    reservation_web_created: 'Site',
    reservations: 'Reservas',
    reservation_summary: 'Resumo da Reserva',
    quotes: 'Orçamentos',
    quote: 'Orçamento',
    new_quote: 'Novo Orçamento',
    quote_status: 'Estado do Orçamento',
    quote_dates: 'Datas do Orçamento',
    create_quote: 'Criar Orçamento',
    error_creating_quote: 'Erro ao criar o orçamento',
    accepted: 'Aceito',
    rejected: 'Rejeitado',
    expired: 'Expirado',
    totals: 'Totais',
    observations_placeholder: 'Escreva observações aqui...',
    quote_deleted: 'Orçamento excluído com sucesso',
    error_deleting_quote: 'Erro ao excluir o orçamento',
    confirm_delete_service: 'Tem certeza de que deseja remover este serviço?',
    service_deleted: 'Serviço removido com sucesso',
    error_deleting_service: 'Erro ao remover o serviço',
    booking_updated: 'Reserva atualizada com sucesso',
    error_updating_booking: 'Erro ao atualizar a reserva',
    quote_status_updated: 'Status atualizado com sucesso',
    quote_client_updated: 'Cliente atualizado com sucesso',
    quote_observations_updated: 'Observações atualizadas com sucesso',
    quote_details: 'Detalhes do Orçamento',
    no_services_quote: 'Nenhum serviço adicionado a este orçamento ainda',
    add_first_service: 'Adicionar Primeiro Serviço',
    no_quotes_found: 'Nenhum orçamento encontrado',
    manual_price: 'Preço Manual',
    please_select_business: 'Por favor selecione uma empresa',
    select_business_to_view_assignments: 'Selecione uma empresa para ver as atribuições',
    select_business_placeholder: 'Selecione uma empresa...',
    reservations_calendar: 'Calendário de reservas',
    reservations_description: 'Gerencie suas reservas de serviço',
    reservations_payments: 'Pagamentos de Reservas',
    reservations_sold: 'Reservas Vendidas',
    reserved_price: 'Preço Reservado',
    reset_price: 'Redefinir preço',
    reset_cost: 'Redefinir custo',
    reset_to_template: 'Redefinir',
    resolve_payment_for_reservation: 'Vincular Pagamento (Reserva #{{id}})',
    resources_and_services: 'Recursos e Serviços',
    restaurant: 'Restaurante',
    restaurants: 'Restaurantes',
    result: 'Resultado',
    results: 'Resultados',
    retry_campaign: 'Fracassado. tente novamente',
    revenue: 'Renda',
    river: 'rio',
    road: 'Terrestre',
    role: 'Função',
    room: 'Quarto',
    room_category: 'Categoria de Quarto',
    room_details: 'Detalhes do Quarto',
    room_number: 'Número do quarto',
    room_plural: 'Quartos',
    room_type: 'Tipo de Quarto',
    rooms: 'Quartos',
    rooms_available: 'Quartos disponíveis',
    route: 'Passeio',
    route_points: 'Pontos turísticos',
    routing: 'Rota',
    sales: 'Vendas',
    save: 'Salvar',
    save_as_new_template: 'Salvar como novo modelo',
    save_and_close: 'Salvar e fechar',
    save_current_preset: 'Salvar Filtros Atuais',
    save_new_cost: 'Economize novo custo',
    save_new_name: 'Salvar novo nome',
    save_new_price: 'Salvar novo preço',
    save_preset_dialog_title: 'Salvar Filtro',
    save_observations: 'Salvar',
    save_providers: 'Salvar Fornecedores',
    save_to_linked_service: 'Salvar no serviço de espelho',
    saved_presets: 'Filtros Salvos',
    saved_to_linked_service: 'Salvo no serviço conectado',
    saved_to_linked_service_cost: 'Salvo no serviço conectado',
    saved_to_linked_service_price: 'Salvo no serviço conectado',
    saving: 'Salvando...',
    saving_providers: 'Salvando fornecedores...',
    saving_providers_success: 'Fornecedores salvos com sucesso',
    schedule: 'Horário',
    scheduling: 'Programação',
    search: 'Pesquisar',
    search_all: 'Pesquisar em todos',
    search_businesses: 'Pesquisar empresas',
    search_by: 'Pesquisar por',
    search_client: 'Cliente de pesquisa',
    search_clients: 'Pesquisar clientes',
    search_existing_person: 'Pesquisar pessoa existente',
    search_inventory: 'Pesquisar inventário',
    search_inventory_items: 'Pesquisar inventário',
    search_rooms: 'Pesquisar salas',
    search_tours: 'Pesquisar excursões',
    search_transfers: 'Pesquisar transferências',
    seats_available: 'assentos disponíveis',
    secondary_color: 'Cor Secundária',
    see_all: 'Ver tudo',
    see_vehicles: 'Ver Veículos',
    select: 'Selecione',
    select_all: 'Selecionar tudo',
    select_all_filtered: 'Selecione todos os filtros',
    select_an_existing_payment_from_client: 'Selecione um pagamento existente do cliente: {{name}}',
    select_assignee: 'Selecione Atribuído',
    select_business: 'Selecione a empresa',
    select_business_type: 'Selecione seu tipo de negócio',
    select_businesses: 'Selecione as empresas',
    select_businesses_to_edit: 'Selecione empresas para editar',
    select_campaign: 'Selecione a campanha',
    select_categories: 'Selecionar Categorias',
    select_city: 'Selecionar Cidade',
    select_client: 'Selecione o cliente',
    please_select_client: 'Por favor selecione um cliente',
    click_to_edit: 'Clique para editar',
    select_cost_by: 'Custo para:',
    select_country: 'Selecione o país',
    select_currency: 'Selecione a moeda',
    select_currency_for_all_bookings: 'Selecionar Moeda para todas as reservas',
    select_date: 'Selecione a data',
    select_date_range: 'Selecione datas',
    select_date_time_and_guests: 'Selecione data, hora e número de hóspedes',
    select_destination: 'Selecione o destino',
    select_destination_city: 'Selecionar Cidade de Destino',
    select_due_date: 'Selecione a data de expiração',
    select_image: 'Selecione a imagem',
    select_inventory: 'Selecione o inventário',
    select_inventory_item: 'Selecione o inventário',
    select_items: 'Selecione itens',
    select_items_placeholder: 'Escolha os itens para mostrar como colunas',
    select_linked_service: 'Selecione serviço de espelho',
    select_money_destination: 'Selecione o destinatário',
    select_money_origin: 'Selecione o remetente',
    select_order: 'Selecione o pedido',
    select_origin: 'Selecione Origem',
    select_pax: 'Selecionar Pax',
    select_paxs: 'Selecione Paxes',
    select_payee: 'Selecionar Beneficiário',
    select_payer: 'Selecionar Pagador',
    select_payment: 'Selecionar pagamento',
    select_pickup_city: 'Selecionar Cidade de Retirada',
    select_price_by: 'Preço para:',
    select_provider: 'Selecione o fornecedor',
    select_recipient: 'Selecionar Destinatário',
    select_recipients: 'Selecione destinatários',
    select_role: 'Selecione a função',
    select_seller_business: 'Selecione a empresa vendedora',
    select_service: 'Selecione o serviço',
    select_service_for_group: 'Selecione o serviço para o pacote',
    select_service_for_reservation: 'Selecione o serviço para reserva',
    select_service_type: 'Selecione o tipo de serviço',
    select_preset: 'Selecionar filtro salvo...',
    select_staff: 'Selecione a equipe',
    select_template: 'Selecionar Modelo',
    select_type: 'Selecionar Tipo',
    select_user: 'Selecione o usuário',
    select_vehicle: 'Selecione o veículo',
    select_zone: 'Selecionar Zona',
    selected: 'Selecionados',
    selected_inventory: 'Inventário selecionado',
    selected_items_total: 'Total dos Itens Selecionados',
    selected_paxs: 'Pacotes selecionados',
    selected_provider: 'Fornecedor Selecionado',
    selected_service: 'Serviço selecionado',
    selected_staff: 'Equipe Selecionada',
    self: 'Próprio',
    self_attributes: 'Atributos Próprios',
    self_attrs: 'Atributos',
    sell_amount: 'Valor das vendas',
    sell_costs: 'Custos de vendas',
    sell_prices: 'Preços de venda',
    sell_prices_discounts: 'Descontos nos preços de venda',
    seller: 'Vendedor',
    seller_and_provider_bookings: 'Reservas de serviços vendidas e fornecidas por',
    seller_business: 'Empresa Vendedora',
    seller_business_description: 'Isso é para acompanhar as vendas de serviços.',
    seller_only_bookings: 'Reservas de serviço vendidas por',
    selling_limit: 'Limite de venda',
    selling_services: 'Serviços que você vende',
    send: 'Enviar',
    send_balance_email: 'Enviar Balanço',
    send_period_balance_email: 'Enviar Resumo do Período por E-mail',
    send_all_balance_email: 'Enviar Balanço Completo por E-mail',
    send_campaign: 'Enviar campanha',
    send_email: 'Enviar e-mail',
    send_tariffs_email: 'Enviar E-mail de Tarifas',
    send_reservations_payment_status_email: 'Enviar Status de Pagamento das Reservas',
    reservations_payment_status: 'Status de Pagamento das Reservas',
    payment_status_filter: 'Filtrar por Status de Pagamento',
    custom_message_optional: 'Mensagem personalizada (opcional)',
    custom_message_placeholder: 'Escreva uma mensagem ou nota adicional para incluir no e-mail...',

    seniors: 'Idosos',
    retired: 'Aposentado',
    retired_plural: 'Aposentados',
    show_retired: 'Mostrar como Aposentado',
    show_retired_description: 'Usar "Aposentado" em vez de "Idoso" para este serviço',
    sent: 'Enviado',
    sent_to: 'Enviado para',
    service: 'Serviço',
    'service-booking-daily-available-limit-exceeded': 'Limite de disponibilidade diária excedido',
    service_attributes: 'Atributos de serviço',
    service_booked_in: 'Reservas de serviço',
    service_booking_price: 'Preço do serviço',
    service_bookings: 'Serviços Designados',
    service_categories: 'Categorias de Serviço',
    service_category: {
        activity: 'Atividade',
        agency: 'Agência',
        apartment: 'Apartamento',
        cabin: 'Cabine',
        cabins: 'Cabines',
        car_rental: 'Aluguel de Veículo',
        hostel_room: 'Quarto de Hostel',
        hotel: 'Hotel',
        house: 'Casa',
        other: 'Outro',
        room: 'Quarto de Hotel',
        tour: 'Tour',
        transfer: 'Transferência',
        villa: 'Vila'
    },
    service_composition: 'Composição do Serviço',
    service_configuration: 'Configurações',
    service_date: 'Data do Serviço',
    service_day: 'Dia de serviço',
    service_default_duration: 'Duração padrão do serviço',
    service_definition: 'Definição de serviço',
    service_details: 'Detalhes do Serviço',
    service_discounts: 'Descontos',
    service_group: 'Pacote de serviços',
    service_group_discount: 'Desconto no pacote de serviços',
    service_group_plural: 'Pacotes de serviços',
    service_groups: 'Pacotes de serviços',
    service_groups_plural: 'Pacotes de serviços',
    service_has_attrs_warning: 'Remova atributos de fallback para adicionar subserviços.',
    service_has_children_warning: 'Não suporta atributos de reserva porque é um pacote.',
    service_key: 'Chave do Serviço',
    service_name: 'Nome do serviço',
    service_not_available: 'O serviço não está disponível nas datas selecionadas',
    service_not_found: 'Serviço não encontrado',
    service_number: 'Nº do serviço',
    service_order: 'Ordem de Serviço',
    service_order_attributes: 'Atributos de ordem de serviço',
    service_order_bookings: 'Reservas de serviço',
    service_order_bookings_description: 'Reservas de serviço neste pedido',
    service_orders: 'Ordens de Serviço',
    service_orders_settings_desc: 'Gerencie opções de ordem de serviço, campos personalizados e regras de numeração.',
    service_paxs: 'Serviço Pax',
    service_period_end: 'Data de Fim do Serviço',
    service_period_start: 'Data de Início do Serviço',
    service_provider: 'Prestador de Serviço',
    service_selected: 'Serviço selecionado',
    service_tags: 'Categorias de Serviço',
    service_title: 'Título do serviço',
    service_type: 'Tipo de serviço',
    services: 'Serviços',
    services_availability: 'Disponibilidade do serviço',
    services_in_this_order: 'Serviços nesta ordem',
    services_landing: {
        categories: {
            rooms_description: 'Quartos de hotel, quartos de hóspedes e serviços de acomodação',
            tours_description: 'Tours guiados, excursões e experiências turísticas',
            transfers_description: 'Transferências de aeroporto, transferências urbanas e serviços de transporte'
        },
        no_results: 'Nenhum serviço encontrado correspondendo a',
        search_placeholder: 'Pesquisar serviços...',
        subtitle: 'Descubra e reserve serviços para seu negócio'
    },
    services_table: 'Tabela de Serviços',
    services_with_calculated_prices: 'Serviços com Novos Preços',
    services_without_dates: 'Serviços sem data',
    services_without_vehicles: 'Nenhuma atribuição de veículo',
    set_coordinator: 'Definir coordenador',
    set_coordinator_all_bookings: 'Definir coordenador para todas as reservas',
    set_provider: 'Definir fornecedor',
    set_provider_all_bookings: 'Definir fornecedor para todas as reservas',
    set_discount_scheme_for_all_services: 'Estabeleça um esquema de descontos para todos os serviços',
    set_group_composition_before_services: 'Configure a composição do grupo para verificar a disponibilidade',
    settings: 'Configurações',
    settings_subtitle: 'Configure e personalize as opções e preferências do seu espaço de trabalho.',
    share: 'Compartilhar',
    share_reservation: 'Compartilhar reserva',
    share_service: 'Compartilhar serviço',
    share_services: 'Compartilhar serviços',
    share_report: 'Compartilhar Relatório',
    share_link_copied: 'Link copiado para a área de transferência!',
    shared_report_title: 'Relatório de Reservas Compartilhado',
    viewing_shared_report_desc: 'Visualizando Relatório de Reservas Compartilhado (Somente Leitura)',
    shared_reports: 'Relatórios Compartilhados',
    sharing_one_service: 'Compartilhando 1 serviço',
    sharing_multiple_services: 'Compartilhando {{count}} serviços',
    sharing_services_description: 'Configure as permissões do cliente abaixo',
    mixed_access: 'Acesso misto',
    partial_access: 'Acesso parcial',
    remove_access: 'Remover acesso',
    services_shared_successfully: 'Serviços compartilhados com sucesso',
    error_sharing_services: 'Erro ao compartilhar serviços',
    services_unshared_successfully: 'Acesso aos serviços removido com sucesso',
    error_unsharing_services: 'Erro ao remover acesso aos serviços',
    shared_kitchen: 'Cozinha Compartilhada',
    shared_room: 'Quarto Compartilhado',
    shared_vehicle: 'Veículo Compartilhado',
    shared_with_me: 'Compartilhado comigo',
    show: 'Mostrar',
    show_bookings: 'Mostrar reservas',
    show_more: 'Ver mais',
    show_on_main_page: 'Mostrar na página principal',
    show_only_services_without_vehicles: 'Mostrar apenas serviços sem veículos',
    show_service_orders: 'Ver pedidos',
    showing_results: 'Mostrando {{count}} de {{total}} resultados',
    signIn: 'Entrar',
    signature_provider: 'Operador: Carimbo, Assinatura, Esclarecimento',
    signature_seller: 'Vendedor: Carimbo, Assinatura, Esclarecimento',
    signingIn: 'Entrando...',
    single_bed: 'Cama de solteiro',
    single_beds: 'Camas de solteiro',
    single_provider: 'único fornecedor',
    sold: 'Vendas',
    sold_by: 'Por',
    sold_by_long: 'Vendido por',
    sold_by_other: 'Vendido por terceiros',
    sort_by: 'Classificar por',
    sort_by_name: 'Classificar por nome',
    sort_by_price: 'Classificar por preço',
    spacial_requirements: 'Requisitos especiais',
    spacial_view: 'Vista Espacial',
    special: 'Especial',
    special_pricing_available_only_for: 'Preços especiais disponíveis apenas para',
    special_pricing_target: 'Destinatário de Preços Especiais',
    split: 'Dividir',
    split_pax_group: 'Dividir grupo de paxs',
    splitting_original_group: 'Dividindo Grupo Original',
    staff: 'Funcionários',
    staff_category_description: 'Selecione ou insira uma nova categoria',
    staff_description: 'Funcionário ou membro da equipe que presta serviços',
    staff_paxs: 'Pessoal e Paxes',
    staff_tag: {
        coordinator: 'Coordenador',
        driver: 'Motorista',
        guide: 'Guia',
        sales: 'Vendas'
    },
    stars: 'Estrelas',
    insufficient_capacity: 'Capacidade insuficiente',
    start: 'Página inicial',
    start_date: 'Data de Início',
    start_hour: 'Hora de início',
    start_time: 'Hora de início',
    starts_between: 'Começa entre',
    status: 'Status',
    status_active: 'Ativo',
    status_paused: 'Pausado',
    status_canceled: 'Cancelado',
    total_expenses_by_currency: 'Total de Despesas por Moeda',
    subscription_readonly_warning: 'Esta despesa recorrente é de apenas leitura e não pode ser modificada.',
    status_color: 'Cor do estado',
    status_color_already_exists: 'A cor do estado já existe',
    status_color_required: 'A cor do estado é obrigatória',
    status_inactive: 'Inativo',
    status_name_already_exists: 'O nome do estado já existe',
    status_name_required: 'O nome do estado é obrigatório',
    status_overdue: 'expirou',
    status_open: 'Aberto',
    status_pending: 'Pendente',
    status_in_progress: 'Em Andamento',
    status_completed: 'Concluído',
    status_closed: 'Fechado',
    status_paid: 'Pago',
    status_cancelled: 'Cancelado',
    priority_low: 'Baixa',
    priority_medium: 'Média',
    priority_high: 'Alta',
    priority_urgent: 'Urgente',
    payment_request: 'Solicitação de Pagamento',
    log_direct_payment: 'Registrar Pagamento Direto',
    payment_type_selector: 'Tipo de Transação',
    generate_tax_voucher: 'Gerar Fatura AFIP',
    invoice_generation_failed: 'Falha ao gerar fatura',
    statuses: 'Statuses',
    stay: 'Alojamento',
    stay_plural: 'Acomodações',
    stock: 'estoque',
    stock_control: 'Controle de estoque',
    stock_control_description: 'Ordens de serviço e estoque serão sincronizados com o serviço',
    store: 'Loja',
    store_name: 'Nome da loja',
    store_website_description: 'Onde a loja online está hospedada?',
    stripe: 'Stripe',
    styling_branding: 'Estilo e Marca',
    submit: 'Enviar',
    subscribe: 'Inscrever-se',
    subscription: 'Assinatura',
    subscription_business: 'Negócios',
    subscriptions: 'Assinaturas',
    expenses: 'Despesas',
    expense: 'Despesa',
    recurring: 'Recorrentes',
    auto_payment: 'Pagamento Automático',
    recurring_expenses: 'Despesas Recorrentes',
    recurring_expense: 'Despesa Recorrente',
    delete_recurring_expense: 'Excluir Despesa Recorrente',
    delete_recurring_expense_confirmation: 'Tem certeza de que deseja excluir a despesa recorrente {{name}}?',
    cancel_recurring_expense: 'Cancelar Despesa Recorrente',
    cancel_recurring_expense_confirmation: 'Tem certeza de que deseja cancelar a despesa recorrente {{name}}?',
    cancel_subscription: 'Cancelar Despesa Recorrente',
    create_recurring_expense: 'Criar Despesa Recorrente',
    edit_recurring_expense: 'Editar Despesa Recorrente',
    recurring_expense_business: 'Negócios',
    recurring_expense_details: 'Detalhes da Despesa Recorrente',
    recurring_expense_details_description: 'Configure os parâmetros desta despesa recorrente.',
    billing_and_cost: 'Faturamento e Custo',
    attribution_and_schedule: 'Atribuição e Programação',
    subtotal: 'Subtotal',
    suite: 'Suit',
    summary: 'Resumo',
    summary_and_send: 'Resumo e envio',
    swimming_pool: 'Piscina',
    synced_inventory_items: 'Itens de inventário sincronizados',
    table: 'Mesa',
    tag_category: 'Categoria da Categoria',
    tag_id: 'ID da Categoria',
    tag_name: 'Nome da Categoria',
    tag_source: 'Fonte da Etiqueta',
    tag_value: 'Valor da Categoria',
    tags: 'Categorias',
    takeoff: 'Sair',
    target_currency: 'Moeda de Destino',
    target_price: 'Preço alvo',
    target_email_message_id: 'Message-ID do e-mail original',
    target_email_message_id_placeholder: 'ex. <CAH=vXh7z6Vp3P9@mail.gmail.com>',
    tariff_exclusivity_notice: 'Estas tarifas especiais estão disponíveis exclusivamente para este cliente',
    tariff_provider: 'Provedor de Tarifas',
    tariffs: 'Taxa',
    tariffs_email: 'E-mail para tarifa',
    tariffs_from: 'Taxa de',
    task: 'Bilhete',
    task_delete: 'Excluir tarefa',
    task_delete_confirmation: 'Tem certeza de que deseja excluir a tarefa?',
    task_delete_confirmation_cancel: 'Cancelar',
    task_delete_confirmation_confirm: 'Excluir',
    task_delete_confirmation_description: 'Esta ação não pode ser desfeita',
    task_delete_error: 'Erro ao excluir a tarefa',
    task_deleted: 'Tarefa excluída com sucesso',
    task_edit: 'Editar tarefa',
    task_show: 'Ver tarefa',
    tasks: 'Ingressos',
    tax_name: 'Razão Social',
    tax_condition: 'Situação Fiscal',
    tax_id: 'CUIL-CUIT',
    tax_id_number: 'ID fiscal',
    tax_id_type: 'Tipo de identificação fiscal',
    template: 'Modelo',
    template_content: 'Conteúdo do modelo',
    template_name: 'Nome do modelo',
    template_name_placeholder: 'Insira um nome para o modelo',
    templates: 'Modelos',
    tenant_name: 'Nome da empresa',
    text: 'Texto',
    theme_colors: 'Cores',
    they_paid_us: 'Eles nos pagaram',
    this_action_cannot_be_undone: 'Esta ação é permanente',
    this_cost_applies_to_all_providers: 'Este custo será aplicado a todos os provedores',
    this_discount_will_be_applied_to: 'Este desconto será aplicado',
    this_is_a_payment: 'Este é um Pagamento',
    this_is_a_refund: 'Este é um Reembolso',
    this_price_applies_to_all_providers: 'Este preço será aplicado a todos os fornecedores',
    this_price_applies_to_selected_provider_only: 'Este preço será aplicado a um fornecedor específico',
    this_week_reservation: 'Reservas desta semana',
    this_weeks_reservations: 'Reservas desta Semana',
    threshold: 'Limite',
    thread_settings_title: 'Tópico da conversa (Opcional)',
    ticket: 'Bilhete',
    ticket_content_placeholder: 'Descreva o ticket (pode incluir links)',
    ticket_number: 'Número do bilhete',
    ticket_title_placeholder: 'Insira o título do ticket',
    ticketed: 'Faturado',
    tickets: 'Ingressos',
    time: 'Hora',
    time_end: 'Hora de Término',
    time_range: 'Horários',
    time_start: 'Hora de Início',
    timeline: 'Itinerário',
    title: 'Título',
    to: 'Até',
    to_businesses: 'Para empresas',
    to_currency: 'Moeda do Destino',
    today: 'Hoje',
    today_service_orders: 'Ordens de serviço de hoje',
    todays_bookings: 'Reservas de Hoje',
    todays_reservations: 'Reservas de hoje',
    todays_vehicle_schedule: 'Agenda de Veículos de Hoje',
    todays_vehicles: 'Veículos de Hoje',
    tomorrow: 'amanhã',
    tomorrow_service_orders: 'Ordens de serviço de amanhã',
    total_after_exchange: 'Total depois de trocar de moeda',
    total_before_exchange: 'Total antes de trocar de moeda',
    total_cost: 'Custo Total',
    total_cost_paid: 'Custos Pagos',
    total_costs: 'Custos',
    total_costs_paid: 'Custos Pagos',
    total_income: 'Total Recebido',
    total_income_received: 'Renda recebida',
    total_my_businesses: 'Total de Empresas',
    total_passengers: 'Total de Passageiros',
    total_pax: 'Total de Paxs',
    total_paxs: 'Total de Paxs',
    total_price: 'Preço Total',
    total_recipients: 'Total de destinatários',
    total_refunded: 'Total Reembolsado',
    total_sells: 'Vendas',
    total_sells_paid: 'Vendas pagas',
    total_ticketed: 'Total Faturado',
    total_unpaid_sells: 'Vendas a receber',
    tour: 'Tour',
    tour_path: 'Rota do tour',
    tour_plural: 'Tours',
    tour_type: 'Tipo de Tour',
    tours: 'Tours',
    tours_available: 'Tours disponíveis',
    train: 'Trem',
    transaction_amount: 'Valor da Transação',
    transaction_amount_exceeds_selected: 'O valor da transação excede o total dos itens selecionados',
    transaction_amount_less_than_selected: 'O valor da transação é menor que o total dos itens selecionados',
    transaction_from: 'De',
    transaction_id: 'ID da Transação',
    transaction_to: 'Para',
    transfer: 'Transferência',
    transfer_placeholder: 'VIP, Exclusivo, etc.',
    transfer_plural: 'Transferências',
    transfers: 'Transferências',
    transfers_available: 'Transferências disponíveis',
    travel_stop: 'Pare',
    trip: 'Viagem',
    trip_reservations: 'Reservas de viagens',
    trips: 'Viajar',
    type: 'Tipo',
    unassigned: 'Não atribuído',
    unassigned_bookings: 'Reservas sem data atribuída',
    unassigned_services: 'Serviços não atribuídos',
    unavailable: 'Indisponível',
    undated: 'Nenhuma data atribuída',
    undated_bookings: 'Reservas sem data',
    undated_services: 'Serviços sem data',
    unlimited: 'Ilimitado',
    unlink_payment: 'Desvincular pagamento',
    unlink_service_order: 'Desvincular ordem de serviço',
    unlinked_only: 'Não atribuído',
    unnamed_client: 'Cliente sem nome',
    unpaid: 'Não Pago',
    unpaid_reservations: 'Reservas Não Pagas',
    unpaid_provider_costs: 'Custos Pendentes do Fornecedor',
    no_unpaid_provider_costs_found: 'Nenhum custo pendente encontrado para este fornecedor',
    cost_payment_status: 'Status de Pagamento do Custo',
    linked_provider_costs: 'Custos de Fornecedor Vinculados',
    link_provider_cost: 'Vincular Custo de Fornecedor',
    no_linked_provider_costs: 'Nenhum custo de fornecedor vinculado',
    booking_already_linked: 'O custo do serviço já está vinculado a este pagamento',
    linked_items: 'Vinculados',
    pending_costs: 'Custos Pendentes',
    paid_costs: 'Custos Pagos',
    client_payment_status: 'Cobrança ao Cliente',
    provider_cost_status: 'Pagamento ao Fornecedor',
    client_payment: 'Cobrança ao Cliente',
    provider_payment: 'Pagamento ao Fornecedor',
    no_client_payments: 'Sem pagamentos do cliente',
    no_provider_payments: 'Sem pagamentos a fornecedores',
    pay_providers: 'Pagar Fornecedores',
    pay_provider: 'Pagar Fornecedor',
    select_provider_to_pay: 'Selecione o fornecedor para registrar o pagamento',
    no_pending_provider_costs: 'Nenhum custo de fornecedor pendente de pagamento',
    unpublished_prices: 'Preços Não Publicados',
    unsaved_changes: 'Alterações não salvas',
    unscheduled_services: 'Serviços não programados',
    unselect: 'Desmarcar',
    unselect_all: 'Desmarcar tudo',
    upcoming_reservations: 'Próximas Reservas',
    update_current_template: 'Atualizar modelo atual',
    update_cost_manually: 'Atualizar custo manualmente',
    update_price_manually: 'Atualizar preço manualmente',
    update_progress: 'Progresso da atualização',
    update_single_attribute: 'Atualizar um atributo',
    update_start_time: 'Atualizar horário de partida',
    updated_at: 'Atualizado em',
    updated_by: 'Atualizado por',
    last_updated: 'Última atualização',
    updating: 'Atualizando',
    upload: 'Carregar',
    upload_image: 'Carregar imagem',
    urgent: 'Urgente',
    use_booking_date: 'Data de reserva do serviço',
    use_magic_link: 'Enviar link de acesso por e-mail',
    use_password_login: 'Entrar com senha',
    use_provider_price: 'Usar preço do fornecedor',
    use_reservation_date: 'Data da Reserva',
    user: 'Usuário',
    user_roles: {
        external: 'Externo',
        internal: 'Interno'
    },
    users: 'Usuários',
    active_user: 'Usuário Ativo',
    email_has_associated_user: 'Este e-mail tem uma conta de usuário associada e não pode ser modificado ou excluído.',
    email_associated_with_user_account: 'Este e-mail está associado a uma conta para {{name}}',
    this_email_is_used_to_login: 'Este e-mail é usado para fazer login',
    no_emails_configured_for_this_business: 'Nenhum e-mail configurado para esta empresa. Clique no botão + acima para adicionar um.',
    users_settings_desc: 'Gerencie usuários, funções e permissões no seu espaço de trabalho.',
    users_with_access: 'Usuários com acesso',
    using_manual_rate: 'Usando taxa manual.',
    valid_from: 'Válido a partir de',
    valid_until: 'Válido até',
    validation: {
        emailInvalid: 'Email inválido',
        emailRequired: 'Email é obrigatório'
    },
    van: 'Eles vão',
    van_rental: 'Aluguel de vans',
    van_rental_plural: 'Aluguel de vans',
    vehicle: 'Veículo',
    vehicle_booking: 'Reserva de veículos',
    vehicle_cost: 'Custo do Veículo',
    vehicle_details: 'Detalhes do Veículo',
    vehicle_information: 'Informações do Veículo',
    vehicle_not_found: 'Veículo não encontrado',
    vehicle_not_selected: 'Veículo não selecionado',
    vehicle_type: 'Tipo de Veículo',
    vehicles: 'Veículos',
    vendor: 'Fornecedor',
    vendors: 'Fornecedores',
    view_all: 'Ver Todos',
    view_customer_portal: 'Consulte o Portal do Cliente',
    view_details: 'Ver detalhes',
    view_order: 'Ver pedido',
    view_payment: 'Veja Pagamento',
    view_public_tariffs: 'Ver Taxa Pública',
    view_ticket: 'Ver ingresso',
    viewer: 'Leitor',
    villa: 'Vila',
    wallet_transfer: 'Carteira Digital',
    we_paid_them: 'Nós pagamos a eles',
    welcome: 'Bem-vindo',
    last_checked: 'Última verificação',
    just_now: 'Agora mesmo',
    ago: 'atrás',
    what_are_you_looking_for: 'O que você está procurando?',
    when: 'Quando',
    when_question: 'Quando?',
    where: 'Onde',
    who: 'Quem',
    who_owns_this_inventory_item: 'Selecione a empresa',
    who_question: 'Quem?',
    wifi: 'Wi-Fi',
    with_and_without_dates: 'Com e sem datas',
    with_dates: 'Somente com datas',
    with_services: 'Com Serviços',
    with_vehicles: 'Com Veículos',
    without_dates: 'Somente sem datas',
    without_service_order: 'Sem ordem de serviço',
    without_services: 'Sem Serviços',
    workspace_name: 'Nome do Grupo de Trabalho',
    yes: 'Sim',
    yes_save_to_linked: 'Sim, salvar no serviço conectado',
    yoga: 'Ioga',
    yoga_class: 'Aula de ioga',
    yoga_class_plural: 'Aulas de ioga',
    yoga_plural: 'Iogas',
    your_company: 'Sua empresa',
    your_name: 'Seu nome',
    zero_assigned: '0 atribuídos',
    row_display_options: 'Opções de Visualização',
    attributes_to_show: 'Atributos a exibir',
    show_pax_phone: 'Mostrar Telefone',
    show_pax_email: 'Mostrar Email',
    show_provider: 'Fornecedor',
    show_coordinator: 'Coordenador',
    please_select_date_range: 'Por favor, selecione um intervalo de datas para carregar reservas.',
    please_select_end_date: 'Por favor, selecione a data de fim.',
    select_active_starts_or_ends: 'Selecione uma data ativa ou intervalo de datas para inspecionar reservas.',
    no_service_bookings_found: 'Nenhuma reserva de serviço corresponde aos filtros selecionados.',
    group_by_category: 'Agrupar por Categoria',
    ungrouped: 'Sem agrupar',
    compress_identical: 'Comprimir idênticos',
    uncompress_identical: 'Descomprimir idênticos',
    identical_services_group: 'Serviços idênticos',
    identical_bookings_count: '{{count}} reservas',
    unit_price: 'cada',
    expand: 'Expandir',
    hide_package_parents: 'Ocultar Pacotes Pai',
    slim_layout: 'Layout Compacto',
    estimated_revenue: 'Ingresos Estimados',
    total_bookings: 'Total de Reservas',
    search_and_filters: 'Busca e Filtros',
    requires_at_least_one_active: 'Requer pelo menos uma seleção de intervalo de datas',
    show_service_title: 'Título do Serviço',
    show_service_order: 'Ordem de Serviço',
    show_reservation: 'Reserva',
    show_client_name: 'Nome do Cliente',
    show_paxs: 'Passageiros',
    show_pax_name: 'Nomes dos Passageiros',
    show_hour: 'Hora',
    show_price: 'Preço',
    ascending: 'Ascendente',
    descending: 'Descendente',
    sort_up: 'Para cima',
    sort_down: 'Para baixo',
    ids: 'IDs',
    group_by_reservation: 'Agrupar por Reserva',
    grouping: 'Agrupamento',
    show_booking_id: 'ID de Booking',
    show_payment_status: 'Status de Pagamento',
    search_by_reservation_dates: 'Buscar por Datas de Reserva',
    search_by_booking_dates: 'Buscar por Datas de Booking',
    general_service_info: 'Serviço e Geral',
    reservation_client: 'Reserva e Cliente',
    finance: 'Finanças',
    allow_edit: 'Habilitar Edição',
    allow_online_reservations: 'Permitir Reservas Online',
    group_by_paxs: 'Agrupar por Passageiros',
    no_paxs_specified: 'Sem passageiros especificados',
    reservation_passengers: 'Reserva / Passageiros',
    booking_start_date: "Data Atribuída ao Serviço",
    show_cost: "Mostrar Custo",
    hide_service_title: "Ocultar Serviço",
    add_to_all_bookings: "Adicionar a Todos os Bookings",
    remove_from_all_bookings: "Remover de Todos os Bookings",
    booking_dates: 'Datas de Booking',
    presets_templates: 'Filtros e Modelos',
    save_preset: 'Salvar Filtro',
    display_settings: 'Configurações de Exibição',
    visible_columns: 'Colunas Visíveis',
    price_updated: 'Preço Atualizado',
    reset_defaults: 'Restaurar Padrões',
    print: 'Imprimir',
    reservations_as_client: 'Reservas como Cliente',
    bookings_as_provider: 'Reservas como Provedor',
    no_bookings: 'Sem reservas registradas',
    register_payment: 'Registrar Pagamento',
    register_payment_from_client: 'Registrar Pagamento de Cliente',
    register_payment_to_provider: 'Registrar Pagamento a Fornecedor',
    create_payment_reminder: 'Criar Lembrete de Pagamento',
    add_new_business: 'Adicionar Empresa',
    add_new_pax: 'Adicionar Passageiro',
    add_new_inventory_item: 'Adicionar Item de Inventário',
    new_task: 'Nova Tarefa',
    search_placeholder: 'Buscar reservas...',
    unassigned_pax: 'Passageiros não atribuídos',
    unassigned_client: 'Clientes não atribuídos',
    unassigned_coordinator: 'Coordenadores não atribuídos',
    unassigned_inventory: 'Inventário não atribuído',
    owes_to: 'deve a',
    settled: 'Liquidado',
    service_id_sort: 'ID',
    received: 'Recebido',
    from_them: 'deles',
    to_them: 'para eles',
    dashboard_subtitle: 'Acesso rápido a operações e atribuições.',
    active_assignments: 'atribuições activas',
    view_assignments: 'Ver atribuições',
    quick_actions_subtitle: 'Crie novas reservas, pagamentos, ordens de serviço, negócios ou outros recursos rapidamente.',
    new_reservation_desc: 'Criar uma reserva confirmada',
    new_pending_reservation_desc: 'Criar uma reserva pendente',
    new_payment_desc: 'Registrar um recebimento ou pagamento de cliente',
    new_service_order_desc: 'Criar uma nova ordem de serviço para organizar pax',
    new_business_desc: 'Registrar um novo fornecedor, cliente corporativo ou agência',
    new_pax_desc: 'Registrar os dados de um passenger recorrente',
    new_service_desc: 'Criar uma nova excursão, traslado, ou atividade de catálogo',
    new_inventory_item_desc: 'Adicionar um veículo, quarto, ou guia atribuível',
    new_task_desc: 'Criar uma tarefa de acompanhamento no painel de controle',
    this_week: 'Esta semana',
    magic_link_description: "Insira seu e-mail e enviaremos um link seguro para fazer login instantaneamente.",
    'magic-link-sent-description': 'Enviamos um link de login para o seu e-mail. Por favor, verifique sua caixa de entrada.',
    send_magic_link: 'Enviar Link de Acesso',
    verifying_session: 'Verificando link...',
    verifying_session_desc: 'Por favor, aguarde enquanto iniciamos sua sessão.',
    create_account_link: "Não tem uma conta? Cadastre-se",
    create_account_description: "Insira seu endereço de e-mail para verificar uma empresa registrada e criar sua conta.",
    back_to_login: "Voltar ao Login",
    user_exists_title: "A Conta já Existe",
    user_exists_desc: "Uma conta com este e-mail já está registrada. Por favor, faça login.",
    no_business_found_title: "Empresa Não Encontrada",
    no_business_found_desc: "Este e-mail não está registrado em nenhuma empresa do Turizi. Por favor, entre em contato com seu administrador.",
    try_another_email: "Tentar Outro E-mail",
    business_found_title: "Empresa Encontrada",
    business_found_desc: "Encontramos uma empresa registrada associada ao seu endereço de e-mail.",
    are_you_part_of_business: "Você faz parte desta empresa?",
    yes_create_account: "Sim, criar minha conta",
    no_go_back: "Não, voltar",
    account_created_title: "Conta Criada!",
    not_found: "Não encontrado",
    select_option: "Selecionar opção",
    go_back: "Voltar atrás",
    business_not_found: "Empresa não encontrada",
    reservation_not_found: "Reserva não encontrada",
    activity_overview: "Resumo de Atividade",
    activity_overview_subtitle: "Monitore reservas, passageiros e ordens de serviço.",
    balance_dates: "Período",
    all_history: "Todo o Histórico",
    select_dates: "Selecionar Datas",
    decrease_font_size: "Diminuir tamanho da fonte",
    increase_font_size: "Aumentar tamanho da fonte",
    premium_feature_title: "Recurso Premium",
    paying_customers_only_heading: "Apenas Clientes Pagos",
    paying_customers_only_description: "Este recurso está disponível apenas para clientes pagos. Entre em contato conosco em hola@turizi.com para atualizar sua conta e desbloquear todos os recursos premium.",
    tax_settings: "Configurações de Impostos",
    tax_settings_desc: "Configure a integração fiscal para faturação eletrónica no seu país.",
    tax_settings_subtitle: "Gerencie faturamento eletrônico e integrações fiscais.",
    afip_arca_settings: "Configurações de ARCA / AFIP (Argentina)",
    afip_arca_settings_desc: "Permite automatizar a criação do certificado e autorizar o Web Service de Fatura Eletrônica (wsfe).",
    afip_sdk_token: "Token de Acesso do Afip SDK",
    cuit: "CUIT",
    arca_username: "CUIT do Usuário da ARCA (Chave Fiscal)",
    arca_password: "Senha Fiscal da ARCA",
    alias: "Alias do Certificado",
    environment: "Ambiente",
    homologation: "Homologação (Testes)",
    production: "Produção",
    generate_certificate: "Gerar Certificado",
    authorize_web_service: "Autorizar Serviço Web",
    certificate_generated: "Certificado Gerado",
    service_authorized: "Serviço Autorizado (wsfe)",
    save_settings: "Salvar Configurações",
    generate_invoice: "Gerar Fatura Eletrônica (AFIP)",
    generate_invoice_desc: "Crie e autorize faturas eletrônicas diretamente com ARCA / AFIP utilizando seu certificado digital ativo.",
    receiver_section: "Receptor / Cliente",
    select_client_selector: "Selecionar Cliente (Pax/Negócio)",
    manual_entry_toggle: "Inserir dados do receptor manualmente",
    receiver_name: "Nome do Receptor / Razão Social",
    invoice_details_section: "Detalhes do Comprovante",
    invoice_type: "Tipo de Comprovante",
    pos_label: "Ponto de Venda",
    select_pos_placeholder: "Selecione o Ponto de Venda",
    pos_required_error: "Deve selecionar um Ponto de Venda",
    concept_label: "Conceito",
    invoice_description_label: "Descrição / Detalhe",
    invoice_description_placeholder: "Ex: Faturamento de Serviços",
    amounts_section: "Valores",
    tax_net_amount: "Valor Líquido",
    iva_rate: "Alíquota de IVA",
    iva_amount: "Valor do IVA",
    total_amount: "Valor Total",
    generate_button: "Gerar Fatura",
    invoice_generated_success: "Fatura gerada com sucesso",
    invoice_number_result: "Número da Fatura",
    cae_result: "CAE",
    cae_expiration_result: "Vencimento CAE",
    afip_error_detail: "Detalhes do Erro de Integração do AFIP",
    afip_error_desc: "O servidor retornou o seguinte erro de validação detalhado ao se comunicar com a API do Afip SDK:",
    integration_steps_title: "Passos e Status da Integração",
    integration_steps_desc: "Siga estes passos para concluir sua integração de faturamento eletrônico com ARCA/AFIP.",
    step_save_credentials: "1. Salvar Credenciais",
    saved: "Salvo",
    pending_config: "Configuração Pendente",
    step_save_credentials_desc: "Preencha o ambiente e suas credenciais da ARCA no formulário acima e clique no botão \"Salvar Configurações\" no final.",
    step_generate_certificate: "2. Gerar Certificado Digital",
    certificate_active: "Certificado Ativo",
    pending_generation: "Geração Pendente",
    step_generate_certificate_desc: "Gera o certificado SSL e a chave privada necessários para autenticar as requisições junto à ARCA.",
    step_authorize_service: "3. Autorizar Serviço Web",
    service_authorized_badge: "Serviço Autorizado (wsfe)",
    pending_authorization: "Autorização Pendente",
    step_authorize_service_desc: "Autoriza o Web Service de Fatura Eletrônica (wsfe) utilizando o certificado digital gerado.",
    step_create_sales_point: "4. Criar Ponto de Venda",
    step_create_sales_point_desc: "Cria um ponto de venda diretamente na ARCA usando suas credenciais.",
    create_sales_point_btn: "Criar Ponto de Venda",
    pos_auto_config_info: "O Turizi irá escanear automaticamente seus pontos de venda existentes na ARCA, identificar o próximo número disponível, registrar um POS dedicado (chamado \"Turizi POS\") para esta integração e manter um registro de todos os outros pontos de venda.",
    auto_configure_sales_point_btn: "Autoconfigurar Ponto de Venda",
    other_detected_sales_points: "Outros Pontos de Venda Detectados",
    sales_point_number: "Número do Ponto de Venda",
    sales_point_name: "Nome de Fantasia",
    sales_point_system: "Sistema de Faturamento",
    sales_point_address: "Endereço Registrado",
    sales_point_address_placeholder: "Selecione ou insira o endereço oficial registrado na ARCA",
    sales_point_address_hint: "Endereço fiscal ou filial declarado no Sistema Registral da ARCA para este CUIT.",
    sales_point_created_success: "Ponto de venda criado com sucesso!",
    sales_point_active: "Ponto de Venda Criado",
    pending_sales_point: "Criação Pendente",
    error_creating_sales_point: "Erro ao criar ponto de venda",
    add_sales_point: "Adicionar Ponto de Venda",
    edit_sales_point: "Editar Ponto de Venda",
    delete_sales_point: "Excluir Ponto de Venda",
    configured_sales_points: "Pontos de Venda Configurados",
    no_sales_points_configured: "Nenhum ponto de venda configurado ainda.",
    confirm_delete_sales_point: "Tem certeza de que deseja excluir este ponto de venda?",
    sales_points_section_title: "Pontos de Venda (POS)",
    sales_points_section_desc: "Gerencie os pontos de venda da AFIP / ARCA e configure-os para uso nos serviços da Turizi.",
    afip_previous_sales_points_title: "Pontos de Venda Carregados da AFIP / ARCA",
    afip_previous_sales_points_desc: "Pontos de venda existentes na AFIP associados ao seu CUIT. Você pode importá-los para uso no Turizi.",
    env_production_portal: "Portal ARCA (Produção)",
    homologation_pos_notice_title: "Ambiente de Testes (Homologação)",
    homologation_pos_notice_desc: "Os pontos de venda listados abaixo são consultados diretamente do portal oficial da ARCA (Produção). Como você está no modo Homologação, o Web Service da AFIP permite emitir notas fiscais de teste com qualquer ponto de venda configurado no Turizi.",
    sync_afip_sales_points_btn: "Carregar / Sincronizar da AFIP",
    sync_afip_sales_points_success: "Pontos de venda sincronizados com a AFIP com sucesso",
    sync_afip_sales_points_error: "Erro ao sincronizar pontos de venda com a AFIP",
    import_to_turizi: "Usar no Turizi",
    already_configured_in_turizi: "Configurado",
    requires_web_services: "Requer Web Services",
    no_sales_points_configured_hint: "Nenhum ponto de venda configurado para faturamento no Turizi. Clique em 'Usar no Turizi' em um dos seus pontos com Web Services carregados acima ou use 'Autoconfigurar Ponto de Venda'.",
    create_afip_sales_point_modal_title: "Criar Ponto de Venda na AFIP / ARCA",
    create_afip_sales_point_modal_desc: "Digite o nome fantasia para registrar um novo ponto de venda oficial em sua conta da AFIP / ARCA habilitado para Web Services.",
    create_in_afip_btn: "Criar na AFIP",
    origin_afip: "AFIP (Pré-existente)",
    origin_user: "Criado pelo Usuário",
    origin_label: "Origem",
    status_in_afip: "Status na AFIP",
    no_afip_points_loaded: "Nenhum ponto de venda carregado da AFIP ainda. Clique em 'Carregar / Sincronizar da AFIP' para consultar seus pontos de venda existentes na ARCA.",
    view_certificate: "Visualizar Certificado",
    copy_certificate: "Copiar Certificado",
    certificate_copied_success: "Certificado copiado para a área de transferência",
    certificate_modal_title: "Certificado SSL Gerado",
    certificate_modal_desc: "Este é o certificado SSL gerado para a sua integração. Você pode copiá-lo se precisar dele para configuração manual.",
    factura_a_requires_cuit: "Factura A requer que o tipo de documento seja CUIT.",
    success: "Sucesso",
    invalid_doc_number: "Por favor, insira um número de documento válido.",
    download: "Baixar",
    no_vouchers: "Nenhum comprovante encontrado",
    afip_vouchers: "Comprovantes AFIP",
    receiver: "Receptor",
    delete_payment: "Excluir Pagamento",
    are_you_sure_delete_payment: "Tem certeza de que deseja excluir este pagamento?",
    delete_payment_warning: "Uma vez excluído, este registro de pagamento não poderá ser recuperado.",
    it_provider: "Provedor de TI",
    gas_station: "Posto de Gasolina",
    last_payment: "Último Pagamento",
    next_payment: "Próximo Pagamento",
    no_payments_registered: "Nenhum pagamento registrado",
    payments_for_recurring_expense_description: "Pagamentos registrados especificamente para esta despesa recorrente.",
    add_payment_for_this_expense: "Registrar Pagamento",
    register_payment_for_recurring_expense: "Registrar Pagamento de Despesa Recorrente",
    debt_percentage: "Percentual de Dívida",
    coverage: "Cobertura",
    total_consumption: "Consumo Total",
    covers: "cobre",
    of_total_consumption: "do consumo total",
    reconciliation: "Conciliação",
    outstanding: "Pendente",
    outstanding_percentage: "% Pendente",
    total_billed: "Faturação Total",
    of_total_billed: "da faturação total",
    past_reservations: "Reservas Passadas",
    future_reservations: "Reservas Futuras",
    all_reservations: "Todas as Reservas",
    reconciliation_explainer_title: "Explicação de Conciliação Automática",
    reconciliation_explainer_desc: "O sistema de conciliação associa os serviços faturados com os recebimentos registrados para calcular o saldo pendente.",
    reconciliation_formula: "Fórmula de Cálculo",
    bookings_found_sales: "Vendemos {{count}} reservas por um total de {{amount}}",
    bookings_found_purchases: "Compramos {{count}} reservas por um total de {{amount}}",
    payments_found_received: "Recebemos {{count}} pagamentos por um total de {{amount}}",
    payments_found_sent: "Enviamos {{count}} pagamentos por um total de {{amount}}",
    reconciliation_details: "Detalhes de Conciliação",
    debits: "Débitos (Valor entregue / pagamento realizado)",
    credits: "Créditos (Valor recebido / recebimento realizado)",
    total_debits: "Total Débitos",
    total_credits: "Total Créditos",
    we_owe_client: "Devemos ao parceiro",
    client_owes_us: "Parceiro nos deve",
    override_payment_status: "Definir como {{status}}",
    payments_sent: "Pagamentos Enviados",
    payments_received: "Recebimentos",
    by_period: "por período",
    linked_paxs: "Passageiros Vinculados",
    no_linked_paxs: "Nenhum passageiro vinculado a esta reserva ainda",
    please_add_paxs_from_the_reservation: "Adicione passageiros a partir da reserva à direita",
    all_reservation_paxs_linked: "Todos os passageiros da reserva estão vinculados",
    add_passengers: "Adicionar Passageiros",
    from_reservation: "Da Reserva",
    send_settlement_by_email: "Enviar liquidação por e-mail",
    send_settlement: "Enviar liquidação",
    sending_history: "Histórico de envios",
    loading_history: "Carregando histórico...",
    no_sending_history: "Sem histórico de envios de e-mail.",
    reservation_issues: "Inconsistências de Reserva",
    we_detected_reservation_issues: "Detectamos {{count}} reservas com dados incompletos ou inconsistentes.",
    no_client_assigned: "Sem cliente associado (Pessoa ou Empresa)",
    no_start_date: "Sem data de início",
    issues: "Inconsistências",
    financial_issues: "Inconsistências Financeiras",
    pax_issues: "Inconsistências de Passageiros",
    business_issues: "Inconsistências de Empresas",
    duplicate_businesses: "Empresas Duplicadas",
    no_duplicate_businesses_found: "Nenhuma empresa duplicada encontrada.",
    pax_business_issues: "Inconsistências de Passageiros e Empresas",
    no_pax_business_issues_found: "Nenhuma inconsistência de nome entre passageiros e empresas encontrada.",
    service_issues: "Inconsistências de Serviços",
    services_without_providers: "Serviços com custo mas sem fornecedores",
    service_has_costs_no_providers: "Este serviço tem custos de venda configurados mas não tem nenhum fornecedor atribuído.",
    duplicate_pax_desc: "Registros de passageiros compartilhando o mesmo nome.",
    missing_lastname_desc: "O passageiro não tem um sobrenome registrado (apenas um único nome).",
    duplicate_business_desc: "Empresas registradas com a mesma razão social ou nome comercial.",
    pax_business_conflict_desc: "Conflito de nome: Existem pessoas e empresas registradas com o mesmo nome exato.",
    reservation_issues_desc: "Reservas com dados incompletos ou inconsistências de faturamento.",
    service_issues_desc: "Serviços ativos com custos mas sem fornecedores configurados.",
    validation_costs_without_providers: "O serviço tem custos configurados mas não tem nenhum fornecedor atribuído.",
    validation_no_price_by_nor_cost_by: "O serviço não tem modalidade de cobrança (price_by) nem de custo (cost_by) configurada.",
    validation_no_active_sell_price: "O serviço não tem nenhum preço de venda ativo (todos os preços estão vencidos ou ausentes).",
    validation_booking_no_provider_with_cost: "Reserva de Serviço #{{bookingId}}: Nenhum fornecedor selecionado, mas tem um custo de {{amount}} {{currency}}.",
    validation_booking_cost_higher_than_sell: "Reserva de Serviço #{{bookingId}}: O custo ({{cost}}) é maior que o preço de venda ({{sellPrice}}).",
    no_service_issues_found: "Nenhuma inconsistência de serviço encontrada.",
    no_issues_found: "Nenhuma inconsistência encontrada.",
    login_popup_title: "Área de Clientes e Parceiros",
    login_popup_text_1: "Faça login",
    login_popup_text_2: "para acessar suas tarifas especiais, verificar seu saldo atual e gerenciar suas reservas.",
    included_in_package: "Incluído no Pacote",
    child_booking_price_tooltip: "O preço deste serviço está incluído no pacote principal.",
    flights: "Voos",
    scheduled_short: "Prog.",
    projected_short: "Projetado",
    actual_short: "Real",
    period_summary: "Resumo do Período",
    payments_applied: "Pagamentos Aplicados",
    total_reservations_amount: "Total das Reservas",
    link_reservation: "Vincular Reserva",
    unlink_reservation: "Desvincular Reserva",
    enter_reservation_id: "Insira o ID da reserva (ex: 1234)...",
    reservation_already_linked: "A reserva já está vinculada",
    period_balance_email_desc: 'Será enviado um resumo das reservas e pagamentos correspondentes ao período selecionado.',
    all_balance_email_desc: 'Será enviado o extrato consolidado com o saldo total acumulado até o momento.',
    document_number: "Nº do Documento",
    delete_link: "Excluir vínculo",
    edit_applied_amount: "Editar valor aplicado",
    amount_must_be_greater_than_zero: "O valor deve ser maior que 0",
    no_attachments: "Sem anexos",
    add_notes: "Adicionar notas...",
    external_code: "Código Externo",
    add_external_code: "Código Externo",
    external_code_placeholder: "Digitar código externo...",
    product: "Produto",
    add_product: "Adicionar Produto",
    create_product: "Criar Produto",
    edit_product: "Editar Produto",
    product_name: "Nome do Produto",
    linked_services: "Serviços Vinculados",
    book_linked_services_question: "Reservar também estes serviços vinculados?",
    no_linked_services: "Sem serviços vinculados",
    add_linked_service: "Adicionar Serviço Vinculado",
    cannot_link_service_to_itself: "Não é possível vincular um serviço a si mesmo",
    service_linked_successfully: "Serviço vinculado com sucesso",
    service_link_removed: "Serviço vinculado removido",
    unlink_service: "Desvincular serviço",
    service_already_linked: "Este serviço já está vinculado",
    no_products_yet: "Nenhum produto ainda",
    products_description: "Os produtos permitem agrupar serviços para visualizá-los e gerenciá-los de forma unificada.",
    no_services_linked: "Nenhum serviço vinculado",
    product_not_found: "Produto não encontrado",
    selected_services_count: "{{count}} serviço(s) selecionado(s)",
    assigned_to_other_product: "Atribuído a outro produto",
    no_product: "Sem Produto",
    group_by_product: "Agrupar por Produto",
    confirm_delete_product: "Tem certeza de que deseja excluir este produto?",
    delete_product: "Excluir produto",
    amount_to_link: "Valor a vincular",
    add_note: "Adicionar nota",
    edit_note: "Editar nota",
    no_notes: "Sem notas adicionadas",
    no_linked_reservations: "Sem reservas vinculadas",
    unallocated_balance: "Saldo não alocado",
    unassigned_money: "Dinheiro não atribuído",
    assigned_to_reservations: "Atribuído a reservas",
    fully_linked: "Totalmente vinculado",
    partially_linked: "Parcialmente vinculado",
    not_linked: "Sem vínculo",
    fully_allocated: "Totalmente alocado",
    over_allocated: "Valor excedido",
    search_payments_placeholder: "Buscar por ID, pagador, destinatário, valor...",
    filter_by_allocation: "Filtrar por alocação",
    allocation_status: "Alocação",
    total_payments_count: "Total de Pagamentos",
    affected_payments: "Pagamentos Afetados / Vinculados",
    unaffected_payments: "Pagamentos Sem Afetar / Sem Vínculo",
    unaffected_payments_desc: "Pagamentos que não estão afetando nenhuma reserva ou ordem",
    no_unaffected_payments: "Todos os pagamentos estão afetando itens (sem pagamentos livres)",
    unaffected_payments_list: "Lista de Pagamentos Sem Afetar",
    auto_assign: "Auto Atribuir",
    auto_assign_payments: "Auto Atribuir Pagamentos",
    auto_assign_payments_title: "Atribuição Automática de Pagamentos",
    auto_assign_payments_desc: "Atribui automaticamente os pagamentos sem vínculo às reservas ou ordens não pagas mais antigas.",
    calculating_auto_assignments: "Analisando pagamentos e encontrando correspondências...",
    auto_assign_no_payments_to_assign: "Nenhum pagamento com possíveis atribuições foi encontrado.",
    auto_assign_confirm: "Confirmar Atribuição",
    auto_assign_confirm_count: "Confirmar Atribuição ({{count}})",
    payments_auto_assigned_success: "Os pagamentos foram atribuídos com sucesso.",
    payments_auto_assigned_error: "Ocorreu um erro ao atribuir os pagamentos.",
    unassigned_reason_zero_amount: "O valor do pagamento é 0",
    unassigned_reason_internal_transfer: "Transferência interna entre contas próprias",
    unassigned_reason_missing_client: "O cliente do pagamento não foi identificado",
    unassigned_reason_missing_provider: "O fornecedor do pagamento não foi identificado",
    unassigned_reason_unknown_direction: "Não foi possível determinar o sentido do pagamento",
    unassigned_reason_no_matching_unpaid_reservations: "Sem reservas não pagas na mesma moeda",
    unassigned_reason_no_matching_unpaid_bookings: "Sem ordens não pagas na mesma moeda",
    will_assign: "Será atribuído",
    partial_assignment: "Atribuição parcial",
    cannot_assign: "Não atribuível",
    remains_unallocated: "ficará sem atribuir",
    assignments_preview: "Pré-visualização de Atribuições",
    total_to_assign: "Total a atribuir",
    target_item: "Item de destino",
    balance_before_after: "Saldo pendente",
    can_assign: "Atribuíveis",
    unassignable: "Não atribuíveis",
    analyzed_payments: "Pagamentos analisados",
    overpaid_discrepancy_title: "Aviso de Cobrança Excedida / Sobrepagamento",
    overpaid_discrepancy_desc: "O valor pago registrado excede o valor total de vendas devido a reservas com sobrepagamentos ou cobranças adicionais.",
    overpaid_amount: "Valor Excedido",
    over_allocated_payments: "Pagamentos Sobre-alocados",
    over_allocated_payments_desc: "Pagamentos cujo valor alocado a itens excede o total do pagamento",
    over_allocated_payments_list: "Lista de Pagamentos Sobre-alocados",
    allocated_amount: "Valor Alocado",
    business_already_exists: "Já existe uma empresa com este nome",
    existing_business_matches: "Empresas existentes",
    no_matching_business_found: "Nenhuma empresa correspondente encontrada",
    type_to_search: "Digite pelo menos 3 caracteres para pesquisar",
    deleted_reservations: "Reservas excluídas",
    deleted_reservation: "Reserva excluída",
    clean_filters: "Limpar Filtros",
    round_trip: "Ida e Volta",
    deleted_by: "Excluído por",
    deleted_at: "Data de exclusão",
    deleted_reservation_banner: "Esta reserva foi excluída em {{date}} por {{user}}.",
    no_deleted_reservations: "Nenhuma reserva excluída",
    original_reservation_id: "ID Reserva Original",
    linked_pax: "Passageiro Vinculado",
    linked_business: "Empresa / Cliente Vinculado",
    document: "Documento",
    document_type: "Tipo de Documento",
    send_email_campaign: "Enviar Campanha por E-mail",
    no_emails_selected: "Nenhum e-mail selecionado",
    sent_email_history: "Histórico de Envios",
    deselect_all: "Desmarcar todos",
    detailed_title: "Título Detalhado",
    no_emails_configured: "Nenhum e-mail configurado para esta empresa",
    select_recipient_emails: "Selecionar E-mails Destinatários",
    no_emails_sent_yet: "Nenhum e-mail enviado ainda",
    step_1_pax: "Passageiros",
    step_1_pax_dates: "Passageiros e Datas",
    step_2_select_service: "Selecionar Serviço",
    step_3_booking_attrs: "Atributos e Detalhes",
    step_next: "Próximo",
    step_back: "Anterior",
    select_a_service: "Selecionar um serviço",
    no_attrs_required: "Sem atributos adicionais requeridos",
    search_service_placeholder: "Buscar serviço...",
    per_person: "por Pessoa",
    back_to_tickets: "Voltar para Tickets",
    priority: "Prioridade",
    delete_ticket: "Excluir Ticket",
    delete_ticket_desc: "Uma vez excluído, este ticket não poderá ser recuperado.",
    ticket_saved_success: "Ticket salvo com sucesso",
    ticket_updated_success: "Ticket atualizado com sucesso",
    opened_on: "abriu este ticket em",
    price_modifiers: "Ajustes de Preço",
    add_price_modifier: "Adicionar Ajuste de Preço",
    remove_price_modifier: "Remover Ajuste de Preço",
    price_modifier_section: "Seção",
    price_modifier_type: "Tipo de Ajuste",
    price_modifier_value: "Valor / Montante",
    price_modifier_description: "Descrição",
    price_modifier_currency: "Moeda",
    fixed_amount: "Valor Fixo",
    taxes: "Impostos",
    manual_adjustment: "Desconto Manual",
    voucher: "Cupom / Voucher",
    surcharge: "Sobretaxa",
    fee: "Taxa",
    add_modifier: "Adicionar Ajuste",
    confirm_delete_price_modifier: "Tem certeza de que deseja remover este ajuste de preço?",
    price_modifier_added: "Ajuste de preço adicionado com sucesso",
    price_modifier_deleted: "Ajuste de preço removido",
    no_price_modifiers: "Sem ajustes de preço",
    all_currencies: "Todas as moedas",
    modifier_operation: "Operação",
    price_modifier_placeholder: "Ex: IVA 21%, Desconto à vista",
    service_bookings_subtotal: "Subtotal de Serviços",
    itemized_bookings: "Detalhamento de Serviços",
    original_amount: "Valor Original",
    modify_price: "Modificar preço",
    modify_prices: "Modificar preços",
    multiply_current_price_by_factor: "Multiplicar o preço atual por este fator",
    services_with_modified_prices: "Serviços com Preços Modificados",
    no_active_price_found: "Nenhum preço ativo encontrado",
    no_services_with_active_price: "Nenhum dos serviços selecionados tem um preço ativo",
    current_price: "Preço atual",
    modified_price: "Preço modificado",
    keep_current_date: "Manter data atual",
    price_amount_currency: "Valor do Preço / Moeda",
    price_start_day: "Data de Início do Preço",
    price_end_day: "Data de Fim do Preço",
    date_asc: "Data Ascendente",
    date_desc: "Data Descendente",
    infant: "Bebê",
    child: "Criança",
    senior: "Idoso",
    filter_target: "Filtrar por data de",
    filter_target_all: "Reserva ou Serviço",
    filter_target_reservation: "Início da Reserva",
    filter_target_booking: "Início do Serviço",
    date_filter_mode: "Modo de Data",
    single_day: "Dia Único",
    clear_date_filter: "Todas as Datas",
    status_all: "Todos os Status",
    role_filter: "Função",
    all_roles: "Todas as Funções",
    total_reservations: "Reservas",
    collapsed_summary_bookings: "serviços",
    collapsed_summary_pax: "passageiros",
    google_account_connected: "Conta do Google conectada com sucesso",
    google_account_connection_failed: "Falha ao conectar a conta do Google",
    google_account_disconnected: "Conta do Google desconectada",
    email_thread_linked_successfully: "E-mail vinculado à reserva com sucesso",
    failed_to_link_email_thread: "Falha ao vincular o e-mail à reserva",
    email_thread_unlinked_successfully: "E-mail desvinculado da reserva",
    email_reply_sent_successfully: "Resposta enviada com sucesso",
    failed_to_send_reply: "Falha ao enviar resposta",
    connecting_google_account: "Conectando ao Google...",
    please_wait_while_connecting: "Por favor, aguarde enquanto a autenticação é concluída.",
    link_email_to_reservation: "Vincular E-mail à Reserva",
    suggested_searches: "Buscas sugeridas",
    search_gmail_inbox_placeholder: "Buscar e-mails no Gmail por assunto, remetente ou texto...",
    searching_emails: "Buscando e-mails...",
    no_subject: "(Sem Assunto)",
    no_emails_found_matching_query: "Nenhum e-mail encontrado para esta busca.",
    enter_search_to_find_emails: "Digite um termo de busca para encontrar e-mails na sua caixa de entrada.",
    email_thread: "Conversa de E-mail",
    messages: "mensagens",
    loading_thread: "Carregando mensagens...",
    write_reply_placeholder: "Escreva sua resposta aqui...",
    send_reply: "Enviar Resposta",
    reply: "Responder",
    reply_all: "Responder a todos",
    no_messages_in_thread: "Nenhuma mensagem neste tópico de e-mail.",
    show_quoted_text: "Mostrar texto citado",
    hide_quoted_text: "Ocultar texto citado",
    quoted_text: "Texto citado",
    emails_and_messages: "E-mails e Mensagens",
    disconnect_google_account: "Desconectar Conta do Google",
    link_email: "Vincular E-mail",
    new_email: "Novo E-mail",
    connect_gmail: "Conectar Gmail",
    connect_gmail_account_title: "Conecte sua conta do Gmail",
    connect_gmail_account_description: "Vincule tópicos de e-mail, leia conversas completas e responda diretamente desta reserva sem sair do app.",
    connect_now: "Conectar Agora",
    open_and_reply: "Ver e Responder",
    unlink: "Desvincular",
    no_linked_emails_yet: "Nenhum e-mail vinculado a esta reserva ainda. Clique em 'Vincular E-mail' ou 'Novo E-mail' para começar.",
    google_auth_success_hint: "Sua conta foi vinculada com sucesso. Você já pode fechar esta janela para retornar à reserva.",
    google_auth_failed_hint: "Ocorreu um error ao autorizar sua conta do Google. Por favor, feche esta janela e tente novamente.",
    invalid_auth_code: "Código de autenticação inválido ou expirado.",
    error_loading_thread_messages: "Não foi possível carregar as mensagens desta conversa",
    google_session_expired_or_invalid_desc: "A sessão da conta do Google pode ter expirado ou estar desconectada. Por favor reconecte sua conta nas configurações do Gmail.",
    reconnect_google_account: "Reconectar Conta do Google",
    recipient_email_required: "Nenhum destinatário válido encontrado para enviar a resposta.",
    cannot_reply_thread_error: "Não é possível responder devido a um erro ao carregar a conversa.",
    close_window: "Fechar janela",
    gmail_link: "Vinculação do Gmail",
    gmail_link_desc: "Conecte uma ou mais contas do Gmail para sua organização para vincular e-mails a reservas e responder a mensagens.",
    connected_gmail_accounts: "Contas do Gmail Conectadas",
    gmail_accounts_section_desc: "Contas do Gmail autorizadas para vincular e interagir com e-mails de clientes e fornecedores.",
    no_gmail_accounts_connected: "Nenhuma conta do Gmail conectada",
    connect_gmail_account: "Conectar Conta do Gmail",
    connect_gmail_account_help: "Conectar uma conta do Gmail permite que sua equipe vincule tópicos de e-mail e responda diretamente dentro das reservas.",
    connect_another_gmail_account: "Conectar outra conta do Gmail",
    status_expired: "Expirado",
    status_insufficient_permissions: "Permissões insuficientes",
    google_insufficient_scopes: "Permissões do Gmail insuficientes. Reconecte sua conta autorizando o acesso ao Gmail.",
    reconnect: "Reconectar",
    disconnect_gmail_account_confirm: "Tem certeza de que deseja desconectar a conta {{email}}? Os e-mails já vinculados não serão removidos.",
    linked_emails: "E-mails vinculados",
    linked_emails_count: "{{count}} e-mail vinculado",
    linked_emails_count_plural: "{{count}} e-mails vinculados",
    open_in_gmail: "Abrir no Gmail",
    recipient_to: "Para",
    name_optional: "Nome (Opcional)",
    all_clients: "Todos os clientes",
    client_business: "Empresa cliente",
    business_specific_price: "Preço específico para empresa",
    this_price_applies_to_all_clients: "Este preço aplica-se a todos os clientes",
    price_applies_to_business: "Preço exclusivo para {{name}}",
    business_contract_price: "Preço acordado para empresa",
    default: "Geral",
    upcoming: "Próximo",
    no_prices_configured: "Nenhum preço configurado para este serviço ainda.",
    no_prices_description: "Adicione tarifas sazonais ou por fornecedor para gerenciar os preços do serviço.",
    no_costs_configured: "Nenhum custo configurado para este serviço ainda.",
    no_costs_description: "Adicione custos de compra de fornecedores para calcular margens e saldos com fornecedores.",
    no_rates_defined: "Sem tarifas definidas",
    registered_payments: "Pagamentos registrados",
    without_scheduled_date: "Sem data programada",
    comments: "Comentários",
    no_tickets: "Não há tickets",
    chat_title: "Chat",
    chat_suggested: "Sugestões",
    chat_new_chat: "Nova conversa",
    chat_welcome_title: "Como posso ajudar você hoje?",
    chat_welcome_subtitle: "Pergunte sobre passeios, excursões, atividades e preços.",
    chat_input_placeholder: "Digite uma mensagem...",
    chat_send: "Enviar",
    chat_services_title: "Serviços",
    chat_services_empty: "Nenhum serviço mencionado ainda.",
    chat_view_service: "Ver",
    chat_typing: "Digitando...",
    chat_hide_services: "Ocultar serviços",
    chat_show_services: "Serviços",
    chat_rate_on_request: "Preço sob consulta",
    chat_cart_title: "Serviços Salvos",
    chat_pin_service: "Salvar",
    chat_pinned_service: "Salvo",
    chat_add_to_cart: "+ Salvar",
    chat_in_cart: "Salvo",
    chat_remove_from_cart: "Remover",
    chat_clear_cart: "Esvaziar",
    chat_checkout: "Reservar",
    chat_cart_total: "Total estimado",
    chat_cart_empty: "Nenhum serviço salvo ainda. Fixe serviços do chat para montar seu pacote.",
    chat_ask_about_pinned: "Consultar sobre estes serviços",
    chat_ask_about_pinned_prompt: "Gostaria de consultar e comparar estes serviços que salvei no meu orçamento: {names}",
    copy_budget: "Copiar Orçamento",
    chat_history_title: "Histórico de conversas",
    chat_history_subtitle: "Retome ou veja conversas anteriores com o assistente.",
    chat_history_empty: "Nenhuma conversa anterior salva.",
    chat_history_empty_hint: "Quando iniciar uma conversa, ela será salva aqui para você continuar a qualquer momento.",
    chat_history_open: "Continuar conversa",
    chat_history_messages: "mensagens",
    chat_history_new_chat: "Iniciar nova conversa",
    chat_history_delete: "Excluir",
    chat_history_active: "Ativo",
    tax_percentage: "Porcentagem de Imposto",
    tax_percentage_desc: "Alíquota de imposto para emissão de comprovantes fiscais deste serviço",
    pos_desc: "Ponto de Venda atribuído a este serviço para faturamento",
    tax_invoicing_settings: "Faturamento e Comprovantes Fiscais",
    generate_tax_receipts: "Gerar Comprovantes AFIP",
    generate_tax_receipts_desc: "Agrupamento automático por Ponto de Venda (POS) e porcentagem de imposto dos serviços da reserva",
    grouped_receipts_to_generate: "Comprovantes agrupados a gerar",
    no_billable_services: "Não há serviços com valor a cobrar superior a 0 nesta reserva.",
    generate_all_receipts: "Gerar todos os comprovantes",
    generate_receipt: "Gerar comprovante",
    receipt_generated: "Comprovante gerado",
    afip_not_configured_alert: "O AFIP não está configurado nesta conta. Por favor, carregue os certificados e dados fiscais nas configurações.",
    download_pdf: "Baixar PDF",
    select_tax_percentage: "Selecione a porcentagem de imposto",
    group_summary: "Resumo do grupo",
    update_reservation_tax_id: "Salvar números de comprovante na reserva",
    receipts_generated_successfully: "Comprovantes gerados com sucesso",
    send_by_email: 'Enviar por E-mail',
    send_voucher_by_email: 'Enviar Comprovante por E-mail',
    destination_email: 'E-mail de Destino',
    voucher_email_sent_successfully: 'Comprovante enviado com sucesso por e-mail',
    failed_to_send_voucher_email: 'Erro ao enviar comprovante por e-mail',
    failed_to_download_pdf: 'Erro ao baixar o PDF',
    taxed_amount: 'Valor Faturado',
    total_vouchers: 'Comprovantes',
    search_afip_vouchers: 'Buscar por cliente, documento, número, reserva ou CAE...',
    tax_settings_bulk_desc: 'Atualização em massa de Ponto de Venda (POS) e Porcentagem de Imposto para os serviços selecionados.',
    modify_pos: 'Modificar Ponto de Venda (POS)',
    modify_tax_percentage: 'Modificar Porcentagem de Imposto',
    filter_by_client: 'Filtrar por cliente',
    filter_by_currency: 'Filtrar por moeda',
    total_invoiced: 'Total Faturado',
    date_type: 'Tipo de Data',
    registration_date: 'Data de Registro',
    registered: 'Registrado',
    no_payment_date: 'Sem data de pagamento',
    due: 'Vence',
    total_sold: 'Total Vendido',
    difference: 'Diferença',
    sold_vs_invoiced: 'Vendido vs Faturado',
    pending_to_invoice: 'Pendente de faturar',
    business_emails: 'E-mails da empresa',
    pax_groups: 'Grupos de Passageiros',
    pax_group: 'Grupo de Passageiros',
    not_assigned_to_services: 'Não atribuído a nenhum serviço',
    add_pax_group: 'Adicionar Grupo',
    edit_pax_group: 'Editar Grupo',
    edit_pax: 'Editar Passageiro',
    single_pax: 'Passageiro Individual',
    pax_group_mode: 'Grupo / Contingente',
    passenger_name: 'Nome do Passageiro',
    passenger_name_placeholder: 'ex. João Silva',
    or_select_existing_person: 'Ou selecionar passageiro existente',
    select_existing: 'Buscar existente',
    delete_pax_group: 'Excluir Grupo',
    delete_pax_group_confirm: 'Tem certeza de que deseja excluir este grupo de passageiros?',
    pax_group_name: 'Nome do Grupo',
    pax_group_name_placeholder: 'ex. Grupo Céu Azul, Escola...',
    coordinator_business: 'Coordenador / Responsável',
    contact_name: 'Nome do Contato',
    contact_phone: 'Telefone de Contato',
    contact_phone_placeholder: 'ex. +55 11 91234-5678',
    pax_group_added_to_all_bookings: 'Grupo vinculado a todos os serviços',
    pax_group_removed_from_all_bookings: 'Grupo desvinculado de todos os serviços',
    pax_group_created_successfully: 'Grupo de passageiros criado com sucesso',
    pax_group_updated_successfully: 'Grupo de passageiros atualizado com sucesso',
    pax_group_deleted_successfully: 'Grupo de passageiros excluído com sucesso',
    pax_group_create_failed: 'Falha ao criar grupo de passageiros',
    pax_group_update_failed: 'Falha ao atualizar grupo de passageiros',
    pax_group_delete_failed: 'Falha ao excluir grupo de passageiros',
    no_pax_groups: 'Nenhum grupo de passageiros criado',
    no_pax_groups_desc: 'Crie grupos ou contingentes para organizar os passageiros nesta reserva.',
    assign_pax_group: 'Vincular Grupo',
    assign_to_service: 'Vincular a este serviço',
    remove_from_service: 'Desvincular do serviço',
    allocated_to_order: 'Alocado na ordem',
    pax_group_members: 'Integrantes do Grupo',
    pax_group_allocation_per_order: 'Alocação de Grupos por Veículo',
    total_group_paxs: 'Total do grupo',
    allocated_in_other_orders: 'Alocados em outras ordens',
    remaining_to_allocate: 'Restante para alocar',
    booking_allocation_updated: 'Alocação atualizada com sucesso',
    booking_allocation_update_failed: 'Falha ao atualizar a alocação',
    booking_removed_from_order_successfully: 'Serviço removido da ordem com sucesso',
    booking_removed_from_order_failed: 'Falha ao remover o serviço da ordem',
    manage_pax_groups: 'Gerenciar Grupos',
    pax_group_empty_warning: 'O grupo não possui passageiros definidos',
    search_coordinator: 'Buscar coordenador...',
    no_coordinator_selected: 'Sem coordenador atribuído',
    all_paxs_in_groups: 'Passageiros em grupos',
    paxs_count_summary: '{{count}} PAX',
    paxs_in_orders_allocated: '{{allocated}} de {{total}} alocados',
    override_group_for_booking: 'Personalizar contagem para este serviço',
    reset_to_default_count: 'Restaurar para padrões do grupo',
    no_passengers_allocated: 'Sem passageiros alocados',
    no_passengers_associated: 'Nenhum passageiro associado',
    add_paxs: 'Adicionar Passageiros',
    edit_paxs: 'Editar Passageiros',
    add_passenger: 'Adicionar Passageiro',
    type_name_press_enter: 'Digite o nome e pressione Enter...',
    group_name_desc: 'Nome do grupo (assume o 1º passageiro por padrão)',
    group_passengers: 'Passageiros do Grupo',
    pax_numbers_breakdown: 'Detalhamento de Passageiros',
    assign_to_bookings: 'Atribuir a Bookings',
    services_linked_count: '{{linked}} de {{total}} serviços vinculados',
    confirm_modify_booking_with_service_order: 'Este serviço já está atribuído a uma ordem de serviço. Deseja continuar e atualizar também a ordem de serviço?',
    phone_2: 'Telefone 2',
    add_second_phone: 'Adicionar segundo telefone',
    chat_on_whatsapp: 'Conversar no WhatsApp',
    assign_all_group: 'Atribuir todo o grupo',
    unassign_group: 'Remover do veículo',
    fully_assigned: 'Totalmente atribuído',
    partially_assigned: 'Parcialmente atribuído',
    not_assigned_to_vehicle: 'Não atribuído a este veículo',
    assigned_pax_groups_to_order: 'Atribuição de Grupos ao Veículo',
    edit_group_allocation_desc: 'Indique quantos passageiros de cada grupo viajam nesta ordem de serviço.',
    legacy_allocation_desc: 'Ajuste a quantidade de passageiros atribuídos a este veículo.',
    assign_all_groups: 'Atribuir todos os grupos',
    unassign_all_groups: 'Remover todos do veículo',
    search_group_placeholder: 'Buscar grupo ou passageiro...',
    allocated: 'Alocados',
    allocations: 'Alocações',
    pax_group_mode_headcount: 'Por Quantidade / Tamanho',
    pax_group_mode_persons: 'Lista de Passageiros',
    pax_group_headcount_desc: 'Defina o grupo indicando a quantidade de passageiros por categoria. Não é necessário registrar nomes individuais.',
    pax_group_persons_desc: 'Adicione os membros deste grupo. Você pode buscar existentes ou digitar um nome para adicioná-lo rapidamente.',
    pax_group_name_hint: 'Identifica este grupo na reserva (ex. família, amigos, contingente). Pode ser preenchido com o primeiro passageiro.',
    add_passenger_to_group: 'Adicionar ao grupo',
    passenger_name_input_placeholder: 'Nome completo do passageiro...',
    document_optional: 'Documento / CPF',
    phone_optional: 'Telefone',
    no_passengers_in_group_yet: 'Ainda não há passageiros adicionados a este grupo',
    type_name_to_add_passenger: 'Digite um nome acima e pressione Enter para começar a montar o grupo.',
    select_and_add: 'Selecionar',
    create_and_add: 'Criar e adicionar',
    reservation_persons_suggestions: 'Sugestões desta reserva',
    group_leader: 'Titular',
    adjust_headcount_manually: 'Ajustar quantidades manualmente',
    hide_headcount_adjustment: 'Ocultar ajuste manual',
    total_headcount: 'Total de Passageiros',
    named_passengers_count: '{{count}} passageiros nominais',
    save_group: 'Salvar Grupo',
    press_enter_to_add: 'Pressione Enter para adicionar',
    or_add_as_new: 'ou adicionar como novo',
    lead_passenger: 'Titular do grupo',
    pax_category: 'Categoria',
    adult: 'Adulto',
    search_allocations_placeholder: 'Buscar por reserva, serviço, grupo ou passageiro...',
    save_booking_allocation: 'Salvar alocação',
    save_all_changes: 'Salvar todas as alterações',
    general_pax: 'Geral',
    select_pax_group: 'Selecionar Grupo de Passageiros',
    all_reservation_paxs: 'Todos os passageiros da reserva',
    customize_group_size: 'Personalizar quantidades manualmente',
    price_generator: 'Gerador de Preços',
    price_generator_desc: 'Calcule e gere preços de venda e custos de fornecedores a partir de um preço base, imposto e diferenciais.',
    seed_price: 'Preço Base (Semente)',
    seed_price_desc: 'Valor base de referência multiplicado pela alíquota de imposto e diferenciais.',
    tax_modifier: 'Modificador de Imposto',
    tax_modifier_desc: 'Multiplicador derivado do imposto (ex. 21% = 1.2100000000) armazenado com alta precisão.',
    diff_category_multipliers: 'Diferenciais por Categoria',
    differential: 'Diferencial',
    diff_default: 'Geral',
    diff_foreigner: 'Estrangeiro',
    diff_child: 'Criança',
    diff_senior: 'Idoso',
    diff_retired: 'Aposentado',
    diff_infant: 'Bebê',
    diff_provider: 'Fornecedor',
    rounding_settings: 'Configurações de Arredondamento',
    round_to: 'Arredondar para',
    round_method: 'Critério de Arredondamento',
    round_nearest: 'Mais próximo (Round)',
    round_ceil: 'Para cima (Ceil)',
    round_floor: 'Para baixo (Floor)',
    cost_multiplier: 'Multiplicador de Custo',
    cost_multiplier_desc: 'Fator multiplicador aplicado ao preço base para determinar o custo do fornecedor.',
    generate_and_apply_prices: 'Gerar e Aplicar Preços',
    generate_and_apply_desc: 'Cria registros ativos nas tabelas de preços de venda e custos de fornecedor para este serviço.',
    save_generator_config: 'Salvar Configuração',
    generator_config_saved: 'Configuração do gerador salva com sucesso',
    apply_to_prices: 'Aplicar aos Preços',
    apply_to_costs: 'Aplicar aos Custos',
    prices_applied_successfully: 'Preços gerados e aplicados com sucesso',
    costs_applied_successfully: 'Custos gerados e aplicados com sucesso',
    preview_sell_prices: 'Preços de Venda Calculados',
    preview_provider_costs: 'Custos de Fornecedor Calculados',
    no_providers_for_costs: 'Este serviço não possui fornecedores associados no momento. Os custos calculados serão aplicados como custo geral (todos os fornecedores).',
    precision_note: 'Modificadores armazenados com 10 dígitos de precisão decimal (ex. 1.2100000000).',
    raw_calculation: 'Cálculo sem arredondar',
    rounded_calculation: 'Resultado final',
    confirm_generate_prices_title: 'Aplicar preços e custos gerados?',
    confirm_generate_prices_desc: 'Isso criará um novo registro de preço de venda e registros de custos para os fornecedores a partir da data selecionada.',
    update_provider_cost_multiplier: 'Atualizar multiplicador na empresa fornecedora',
    start_day: 'Data de Início',
    end_day: 'Data de Término',
    seed_prices_history: 'Histórico de Preços Base (Semente)',
    no_seed_prices: 'Nenhum preço semente registrado',
    use_this_seed_price: 'Usar',
    dates_used: 'Datas utilizadas',
    pax_discrepancy: 'Discrepância de Passageiros',
    pax_discrepancy_count_mismatch: 'A quantidade de passageiros atribuídos ({{assigned}}) não coincide com o total da reserva ({{booking}}).',
    pax_discrepancy_category_mismatch: 'A composição por categoria de passageiros não coincide com a reserva.',
    pax_discrepancy_assigned: 'Atribuídos',
    pax_discrepancy_booking: 'Reserva',
    prices_and_costs: 'Preços e Custos',
    margins: 'Margens',
    prices_and_costs_description: 'Compare preços de venda e custos de fornecedores em períodos idênticos para analisar margens e diferenças.',
    markup: 'Margem s/ custo',
    net_margin: 'Margem Bruta',
    loss: 'Prejuízo',
    unit_profit: 'Lucro por Unidade',
    no_cost_for_period: 'Sem custo configurado para este período',
    no_price_for_period: 'Sem preço configurado para este período',
    no_periods_found: 'Nenhum período de preços ou custos encontrado',
    current_active_period: 'Período Ativo Atual',
    average_margin: 'Margem Média',
    total_periods: 'Total de Períodos',
    cost_exceeds_price: 'Atenção: O custo supera o preço de venda!',
    table_view: 'Tabela',
    cards_view: 'Cartões',
    all_tiers: 'Todas as categorias de passageiros',
    passenger_tiers_breakdown: 'Detalhamento por categorias de passageiros',
    different_currencies_warning: 'O preço e o custo usam moedas diferentes. A diferença não pode ser calculada diretamente.',
    cost_status_missing: 'Custo Ausente',
    price_status_missing: 'Preço Ausente',
    price_and_cost_comparison: 'Comparação de Preços e Custos',
    highest_margin: 'Margem Máxima',
    lowest_margin: 'Margem Mínima',
    sort_by_margin: 'Margem',
    sort_by_diff: 'Diferença',
    days_duration: '{{count}} dias',
    days_duration_single: '1 dia',
    pax_list: 'Lista de Passageiros',
    add_all: 'Adicionar todos',
    transport: 'Transporte',
    searching: 'Buscando',
    search_by_phone: 'Buscar por Telefone',
    search_by_document_number: 'Buscar por Documento',
    search_by_email: 'Buscar por Email',
    search_or_add_new_passenger: 'Buscar ou Criar Pax',
    booking_size: 'Tamanho na Reserva',
    sync_booking_size_from_groups: 'Sincronizar tamanho da reserva pelos grupos',
    sync_group_size_from_persons: 'Calcular pelos passageiros selecionados',
    reset_to_group_defaults: 'Restaurar padrões do grupo',
    customized_for_booking: 'Personalizado',
    select_passengers_for_booking: 'Passageiros neste serviço',
    sell_price: 'Preço de Venda',
    calculate_costs_from: 'Calcular a partir de',
    pax_profile_title: 'Perfil como Passageiro (Pax)',
    business_as_pax_explanation: 'Um Cliente ou Fornecedor também pode ter um perfil de Pessoa (Pax) para ser atribuído como passageiro ou equipe em reservas.',
    business_profile_title: 'Perfil como Cliente / Fornecedor',
    person_as_business_explanation: 'Uma Pessoa (Pax) também pode ter um perfil de Cliente ou Fornecedor para ser titular de reservas, gerenciar pagamentos ou fornecer serviços.',
    create_as_pax: 'Criar como Passageiro',
    link_existing_pax: 'Vincular existente',
    link_or_create_business: 'Vincular ou Criar Cliente/Fornecedor',
    change_linked_pax: 'Alterar',
    confirm_unlink_pax: 'Desvincular o passageiro associado a este cliente/fornecedor?',
    confirm_unlink_business: 'Desvincular o cliente/fornecedor associado a esta pessoa?',
    view_pax_profile: 'Ver perfil de passageiro',
    view_business_profile: 'Ver perfil de cliente/fornecedor',
    delete_price: 'Excluir Preço',
    delete_cost: 'Excluir Custo',
    expand_all_costs: 'Expandir todos os custos',
    collapse_all_costs: 'Recolher todos os custos',
    show_costs: 'Mostrar custos',
    hide_costs: 'Ocultar custos',
    select_sell_price: 'Selecionar preço de venda',
    create_sell_price_first: 'Você deve criar pelo menos um preço de venda antes de adicionar um custo.',
    show_pax_list: 'Mostrar Passageiros',
    only_first_pax: 'Apenas 1º Passageiro',
    retentions: 'Retenções de Impostos',
    add_retention: 'Adicionar Retenção',
    retention_type: 'Tipo de Retenção',
    retention_types: {
        ganancias: 'Imposto de Renda (Ganancias)',
        iibb: 'Receita Bruta (IIBB)',
        iva: 'IVA',
        suss: 'Seguridade Social (SUSS)',
        other: 'Outra Retenção'
    },
    retention_jurisdiction: 'Jurisdição / Província',
    retention_jurisdiction_placeholder: 'ex. CABA, Buenos Aires, Salta...',
    retention_certificate_number: 'Nº do Certificado',
    retention_certificate_placeholder: 'ex. 0001-00012345',
    retained_amount: 'Total Retido',
    net_cash_amount: 'Líquido Transferido / Dinheiro',
    total_settled_amount: 'Total Quitado (com retenções)',
    no_retentions: 'Nenhuma retenção registrada',
    upload_certificate: 'Enviar Certificado',
    provider_tax_vouchers: 'Comprovantes do Fornecedor',
    add_provider_voucher: 'Adicionar Comprovante do Fornecedor',
    link_existing_voucher: 'Vincular Comprovante Existente',
    register_new_voucher: 'Registrar Novo Comprovante',
    emitted_vouchers: 'Emitidos (Vendas)',
    received_vouchers: 'Recebidos (Fornecedores)',
    issuer_provider: 'Fornecedor Emissor',
    issuer_cuit: 'CUIT do Emissor',
    issue_date: 'Data de Emissão',
    voucher_number_label: 'Número do Comprovante',
    voucher_type_label: 'Tipo de Comprovante',
    cae_optional: 'CAE (Opcional)',
    cae_expiration_optional: 'Venc. CAE (Opcional)',
    link_to_other_bookings_of_provider: 'Vincular também a outros serviços deste fornecedor',
    no_provider_vouchers: 'Nenhum comprovante de fornecedor vinculado',
    provider_voucher_created: 'Comprovante de fornecedor registrado com sucesso',
    provider_voucher_linked: 'Comprovante vinculado com sucesso',
    provider_voucher_unlinked: 'Comprovante desvinculado',
    select_existing_voucher: 'Selecionar comprovante recebido',
    no_received_vouchers_for_provider: 'Nenhum outro comprovante encontrado para este fornecedor',
    upload_voucher_file: 'Anexar PDF / Imagem do Comprovante',
    retention_percentage: 'Alíquota (%)',
    retention_preset: 'Regime / Alíquota padrão',
    select_service_bookings_for_voucher: 'Serviços vinculados na reserva',
    select_at_least_one_booking: 'Selecione pelo menos um serviço'
};





